{
  "Utilities": "خدمات",
  "Prime Icons": "أيقونات رئيس الوزراء",
  "Pages": "الصفحات",
  "Landing": "الهبوط",
  "Auth": "مصادقة",
  "Login": "تسجيل الدخول",
  "Access Denied": "تم الرفض",
  "Crud": "الخام",
  "Not Found": "غير معثور عليه",
  "Empty": "فارغ",
  "Checked fields cannot be empty": "لا يمكن ترك الحقول المحددة فارغة",
  "Hierarchy": "تَسَلسُل",
  "Submenu 1": "القائمة الفرعية 1",
  "Submenu 1.1": "القائمة الفرعية 1.1",
  "Submenu 1.1.1": "القائمة الفرعية 1.1.1",
  "Submenu 1.1.2": "القائمة الفرعية 1.1.2",
  "Submenu 1.1.3": "القائمة الفرعية 1.1.3",
  "Submenu 1.2": "القائمة الفرعية 1.2",
  "Submenu 1.2.1": "القائمة الفرعية 1.2.1",
  "Submenu 2": "القائمة الفرعية 2",
  "Submenu 2.1": "القائمة الفرعية 2.1",
  "Submenu 2.1.1": "القائمة الفرعية 2.1.1",
  "Submenu 2.1.2": "القائمة الفرعية 2.1.2",
  "Submenu 2.2": "القائمة الفرعية 2.2",
  "Submenu 2.2.1": "القائمة الفرعية 2.2.1",
  "Get Started": "البدء",
  "Documentation": "توثيق",
  "View Source": "أنظر المصدر",
  "Scale": "حجم",
  "Menu Type": "نوع القائمة",
  "Static": "ثابتة",
  "Input Style": "نمط الإدخال",
  "Outlined": "موجز",
  "Filled": "مملوء",
  "Ripple Effect": "أثرمضاعف",
  "Bootstrap": "بوتستراب",
  "Material Design": "تصميم المواد",
  "Material": "المصادر",
  "Material Design Compact": "تصميم المواد مدمج",
  "Tailwind": "الريح الخلفية",
  "Fluent UI": "واجهة مستخدم بطلاقة",
  "PrimeOne Design - 2022": "تصميم PrimeOne - 2022",
  "PrimeOne Design - 2021": "تصميم PrimeOne - 2021",
  "Polls": "الاستبيانات",
  "Send Notification": "إرسال الإشعار",
  "control Board": "لوحة التحكم",
  "Organizational units": "الوحدات التنظيمية",
  "Single User Only": "مستخدم واحد فقط",
  "Exercises": "التدريبات",
  "Sustainable training": "التدريب المستدام",
  "training courses": "الدورات التدريبية",
  "user name": "اسم المستخدم",
  "phone number": "رقم الهاتف",
  "Select the organizational unit": "حدد الوحدة التنظيمية",
  "Business talk": "حديث الأعمال",
  "The Saudi Business Center is pleased to invite you to attend a meeting": "يسر المركز السعودي للتنافسية والأعمال الاقتصادية دعوتكم لحضور لقاء ",
  "Nine Tenths in the Business Sector, which will be held on Wednesday, 11/9/2022, from 3:30 pm to 5:00 pm at the headquarters of the Saudi Business Center - Riyadh Front N10 Building.": "تسعة أعشار في قطاع الأعمال والذي سينعقد يوم الاربعاء الموافق 2022/11/9 من الساعة 3:30 مساءً حتى 5:00 مساءً في مقر المركز السعودي للتنافسية والأعمال-واجهة الرياض N10 مبنى",
  "If you would like to attend the meeting, we kindly ask you to fill out the following information": "في حال رغبتكم في حضور اللقاء نأمل كرمًا تعبئة البيانات التالية",
  "START": "يبدأ",
  "Questions marked with a": "الأسئلة التي تحمل علامة أ",
  "are required": "مطلوبة",
  "Next Question": "السؤال التالي",
  "Full Name": "الاسم الثلاثي",
  "Are you an individual or facility?": "هل أنت فرد أو منشأة؟",
  "Cheese": "جبنه",
  "Nationality": "الجنسية",
  "contact number": "رقم التواصل",
  "Employer, if any": "جهة العمل ان وجدت",
  "Done": "مكتمل",
  "Please select data": "يرجى اختيار البيانات",
  "Identified users": "المستخدمين الذين تم تحديدهم",
  "Data panel": "لوحة المعلومات",
  "TRAINING_CREATED": "مسودة",
  "APPROVED": "مقبول",
  "REJECTED": "مرفوض",
  "REVISION": "مراجعة",
  "Go Back": "عُد",
  "active": "نشط",
  "ACTIVE": "نشط",
  "INACTIVE": "غير نشط",
  "Inactive": "غير نشط",
  "acceptable": "مقبول",
  "ADD SERVICE": "إضافة البيانات",
  "EDIT": "تعديل",
  "OU CHANGE": "تغيير التصنيف",
  "No type": "لا يوجد",
  "Accepted": "المقبولة",
  "Draft": "مسودة",
  "Rejected": "تم الرفض",
  "Published": "المنشورة",
  "PUBLISHED": "المنشورة",
  "weekly": "الأسبوعية",
  "Consolidated": "الورش الموحدة",
  "Sent for review": "تم تحديد الحقيبة التدريبية للمراجعة",
  "save": "حفظ",
  "Assembly": "التجميع",
  "Chart type": "نوع الرسم البياني",
  "Chart name": "اسم الرسم البياني",
  "Schedule": "جدول",
  "name": "اسم",
  "Invalid JSON": "JSON غير صالح",
  "Create a course": "إنشاء دورة",
  "a step": "خطوة",
  "the address": "العنوان",
  "Please write the address": "يرجى كتابة اسم الدورة التدريبية",
  "Address required": "العنوان مطلوب",
  "Please write in Arabic": "الرجاء الكتابة بالعربية",
  "Description": "الوصف",
  "Description required": "الوصف مطلوب",
  "Image of the training course": "صورة الدورة التدريبية",
  "Add image": "إضافة صورة",
  "Duration": "المدة الزمنية",
  "Details of the time period": "تفاصيلالمدةالزمنية",
  "The date :": "التاريخ :",
  "Start time:": "وقت البدء :",
  "End time :": "وقت الانتهاء :",
  "Test details": "تفاصيل الاختبار",
  "Test type:": "نوع الاختبار :",
  "Survey details": "تفاصيل الاستبيان",
  "Survey type:": "نوع الاستبيان :",
  "The description :": "الوصف :",
  "The coach :": "المدرب :",
  "Workshop link :": "رابط ورشة العمل :",
  "Building :": "مبنى :",
  "City :": "المدينة :",
  "Select the type": "حدد النوع",
  "Congrats!A new course has been successfully created.With our wishes for success and payment.": "مبروك! تم إنشاء دورة جديدة بنجاح. مع تمنياتنا لك بالتوفيق والسداد.",
  "the next": "التالي",
  "Exit": "خروج",
  "Choose a test": "اختر اختبار",
  "Choose a poll": "اختر استبيان",
  "Choose": "اختر",
  "Create a workshop": "إنشاء ورشة العمل",
  "Choose the coach": "اختر المدرب",
  "The trainer is required": "المدرب مطلوب",
  "online?": "اونلاين؟",
  "Workshop link": "رابط ورشة العمل",
  "video link": "رابط الفيديو",
  "the coach": "المدرب",
  "Paste the link here": "ألصق الرابط هنا",
  "Please write the full address": "يرجى كتابة العنوان الكامل",
  "The name is required": "الاسم مطلوب",
  "Choose the city": "اختر المدينة",
  "Course title": "عنوان الدورة التدريبية",
  "The title is required": "العنوان مطلوب",
  "Training sessions": "الجلسات التدريبية",
  "Training timeline": "الجدول الزمني للدورة التدريبية",
  "the exams": "الاختبارات",
  "Surveys": "الاستبيانات",
  "Sources": "المصادر",
  "to download": "تنزيل",
  "Contents": "المحتويات",
  "Training Program Updated": "تم تحديث برنامج التدريب",
  "Training course content": "محتوى الدروة التدريبية",
  "Course created and added successfully": "تم إنشاء الدورة التدريبية وإضافتها بنجاح",
  "Course created but failed to update parent. Please refresh the page.": "تم إنشاء الدورة التدريبية بنجاح ولكن فشل تحديث البيانات الرئيسية. يرجى تحديث الصفحة",
  "Add a user": "إضافة مستخدم",
  "Users updated successfully!": "تم تحديث المستخدمين بنجاح",
  "Invalid emails skipped": "تم تخطي رسائل البريد الإلكتروني غير الصالحة",
  "users added successfully": "تم إضافة المستخدمين بنجاح",
  "Starting time": "وقت البدء",
  "The start time is required": "وقت البدء مطلوب",
  "Time to finish is required": "وقت الانتهاء مطلوب",
  "Finish": "موافق",
  "The workshop will be held online": "ستقام ورشة العمل أون لاين",
  "Links": "الروابط",
  "Videos": "مقطع فيديو",
  "Your browser does not support this type of video": "متصفحك لا يدعم هذا النوع من الفيديو",
  "Link": "الرابط",
  "In attendance": "حضوري",
  "Add a file": "إضافة ملف",
  "construction": "إنشاء",
  "create anything": "إنشاء",
  "end time": "وقت الانتهاء",
  "online": "أون لاين",
  "Via videos": "عبر مقاطع الفيديو",
  "Please enter the link": "يرجى ادخال الرابط",
  "file name": "اسم الملف",
  "Please write the file name": "يرجى كتابة اسم الملف",
  "The file name is required": "اسم الملف مطلوب",
  "The progress bar according to the organizational unit": "شريط التقدم على حسب الوحدة التنظيمية",
  "Link to the workshop": "رابط ورشةالعمل",
  "Test type": "نوع الاختبار",
  "Current": "الحالية",
  "Complete": "المكتملة",
  "View details": "عرض التفاصيل",
  "Add participants": "إضافة مشاركين",
  "Details of the course": "تفاصيل الدورة",
  "the job": "العمل",
  "the video": "الفيديو",
  "the name of pdf": "اسم الحقيبة التدريبية",
  "required": "إلزامي",
  "Poll type": "نوع الاستبيان",
  "Headquarters address": "عنوان المقر",
  "Home page": "الصفحة الرئيسية",
  "Ministry of Human Resources and Social Development": "وزارة الموارد البشرية والتنمية الاجتماعية",
  "Accept": "قبول",
  "Agree": "موافق",
  "Reason": "سبب",
  "The name of the graph": "اسم الرسم البياني",
  "Graph": "نوع الرسم البياني",
  "not good": "غير صالح",
  "Cancellation": "إلغاء",
  "Save": "حفظ",
  "Classification of the services of the entity": "تصنيف خدمات الجهة",
  "Find a name or number": "ابحث عن اسم أو رقم",
  "file": "ملف",
  "Data label": "العنوان",
  "Organizational unit": "الوحدة التنظيمية",
  "Organizational Unit": "الوحدة التنظيمية",
  "Choose an organizational unit": "اختر الجهة التنظيمية",
  "Choose an enity unit": "اختر الجهة",
  "Choose Type": "اختر النوع",
  "addition": "إضافة",
  "Inspection": "معاينة",
  "Cancel": "إلغاء الأمر",
  "Add the Excel file to download the data": "قم بإضافة ملف الاكسل لتحميل البيانات",
  "Add all": "إضافة الكل",
  "Confirmation of change": "تأكيد التغيير",
  "Determine the organizational unit": "حدد الوحدة التنظيمية",
  "Adding an organizational unit": "إضافة وحدة تنظيمية",
  "picture": "صورة",
  "icon": "أيقونة",
  "Image": "الصورة",
  "agree on": "موافق",
  "Data generation": "توليد البيانات",
  "Download all data": "تحميل كافة البيانات",
  "Save as a draft": "حفظ كمسودة",
  "Enter the name of the draft": "ادخل اسم المسودة",
  "the name":"الاسم",
  "Download all": "تحميل الكل",
  "Discuss": "بحث",
  "Choose the organizational unit": "اختر الوحدة التنظيمية",
  "Address update": "تحديث العنوان",
  "Select": "حدد خدمة",
  "Update Type": "تحديث النوع",
  "Add a category": "إضافة تصنيف",
  "Add a new template": "إضافة قالب جديد",
  "Update the template": "تحديث القالب",
  "Selected data": "البيانات المختارة",
  "Label": "الاسم",
  "Classifications": "التصنيفات",
  "Classification modification": "تعديل التصنيف",
  "Download data": "تنزيل البيانات",
  "Add a new category": "إضافة تصنيف جديد",
  "Yes": "نعم",
  "no": "لا",
  "Research": "بحث",
  "Search filter": "شريط البحث",
  "Types of files": "أنواع الملفات",
  "Date": "التاريخ",
  "History": "التاريخ",
  "Organizational": "وحدة تنظيمية",
  "File types": "أنواع الملفات",
  "Aphtrafts": "الافترايفكتس",
  "download file": "تحميل الملف",
  "Validity label": "اسم الصلاحية",
  "Sub interface": "الواجهة الفرعية",
  "Basic interface": "الواجهة الأساسية",
  "select all": "تحديد الكل",
  "All": "كل الإشعارات",
  "My": "إشعاراتي",
  "User Events old": "إشعارات المستخدم",
  "User Events": "المستخدمين المسجلين موخرًا",
  "Data Events": "إشعارات تحديث المحتوى",
  "Knowledge Library Events": "إشعارات مكتبة المعرفة",
  "User updated successfully": "تم تفعيل المستخدم بنجاح",
  "Select a tag": "حدد علامة",
  "Add a new role": "أضف دورًا جديدًا",
  "Create an interface": "إنشاء واجهة",
  "Create a new role": "إنشاء دور جديد",
  "The role update": "تحديث الدور",
  "Rearrangement": "إعادة ترتيب",
  "Add external users": "إضافة مستخدمين خارجيين",
  "Add a logo": "إضافة شعار",
  "an offer": "معاينة",
  "Add a question": "إضافة سؤال",
  "The text of the answer is multiple": "نص الإجابة متعدد",
  "the classes": "الصفوف",
  "separator": "الفاصل",
  "break": "فاصل",
  "the page": "الصفحة",
  "Thank you the text of the page": "نص صفحة الشكر",
  "Edit footer": "تحرير تذييل",
  "Update footer": "التذييل",
  "Update the thank you page text": "نص صفحة الشكر",
  "Add external elements": "أضف العناصر الخارجية",
  "Add external elements Survey": "إضافة عنصر خارجي",
  "Add emails": "إضافة رسائل البريد الإلكتروني",
  "Add emails survey": "البريد  الإلكتروني",
  "Finished": "موافق",
  "Add type": "إضافة نوع",
  "Update survey type": "تحديث نوع الاستبيان",
  "Begins": "ابدأ",
  "Email is required": "البريد الالكتروني مطلوب",
  "Please enter a valid email address": "يرجى إدخال عنوان بريد إلكتروني صالح",
  "Select an option": "حدد اختيارا",
  "Comment saved":"تم حفظ التعليق بنجاح",
  "Powered by": "مشغل بواسطة",
  "New poll": "استبيان جديد",
  "Survey name": "اسم الاستبيان",
  "Created": "تاريخ الإنشاء",
  "Modified": "تاريخ التعديل",
  "Responses": "استجابات",
  "selected": "تم التحديد",
  "Update survey": "تحديث استبيان",
  "Create a new survey": "إنشاء استبيان جديد",
  "Create a training program": "إنشاء برنامج تدريبي",
  "Please write the title of the training program": "يرجى كتابة عنوان البرنامج التدريبي",
  "Description is required": "الوصف مطلوب",
  "Photo of the training program": "صورة البرنامج التدريبي",
  "Please select the type": "يرجى تحديد النوع",
  "Please select a start time": "يرجى تحديد وقت البدء",
  "Please select an end time": "يرجى تحديد وقت الانتهاء",
  "Completion time required": "وقت الانتهاء مطلوب",
  "Create a request": "إنشاء طلب",
  "Administration": "الإدارة",
  "Course requests": "أنواع التدریب",
  "Course history": "تاريخ الدورة التدريبية",
  "the month": "الشهر",
  "Create the course": "إنشاء الدورة التدريبية",
  "to publish": "نشر",
  "Disable": "تعطيل",
  "activation": "تفعيل",
  "Preview": "معاينة",
  "the reason": "السبب",
  "View course details": "عرض تفاصيل الدورة التدريبية",
  "Add course requests": "إضافة طلبات الدورة التدريبية",
  "Add a new type": "إضافة نوع جديد",
  "Standardized training": "ورش موحدة",
  "Schedule training sessions": "حدد جلسات تدريبية",
  "Add an organizational unit": "إضافة وحدة تنظيمية",
  "Custom units": "الوحدات المخصصة",
  "Not selected": "لم يتم حدد",
  "Select the year": "حدد السنة",
  "Add months": "إضافة أشهر",
  "review": "مراجعة",
  "Reviewed": "تمت المراجعة",
  "Create a training course": "إنشاء دورة تدريبية",
  "User details": "تفاصيل المستخدم",
  "Type the email address": "اكتب عنوان البريد الإلكتروني",
  "Email required": "البريد الإلكتروني مطلوب",
  "Email is invalid": "البريد الإلكتروني غير صالح",
  "E-mail address": "عنوان البريد الإلكتروني",
  "Mobile Phone Number": "رقم الهاتف المحمول",
  "Job title": "المسمى الوظيفي",
  "Users": "المستخدمون",
  "Table of dates": "جدول التواريخ",
  "Attempted": "المكتملة",
  "survey": "استبيان",
  "personal information": "معلومات شخصية",
  "full name": "الاسم الكامل",
  "Sex": "الجنس",
  "National Identity": "الهوية الوطنية",
  "Performance/gamification": "الأداء / التلعيب",
  "The progress bar": "شريط التقدم",
  "Coming": "القادمة",
  "comments": "التعليقات",
  "Commented Pages": "الصفحات المعلق عليها",
  "No pages with comments": "لا توجد صفحات بها تعليقات",
  "Overall Feedback": "ملاحظات عامة",
  "Progress bar by organizational unit": "شريط التقدم حسب الجهات",
  "male": "ذكر",
  "feminine": "أنثى",
  "First Name": "الاسم الأول",
  "Type the first name": "اكتب الاسم الأول",
  "the second name": "الاسم الثاني",
  "Type the second name": "اكتب الاسم الثاني",
  "Type the second name (optional)": "اكتب الاسم الثاني (اختياري)",
  "family name": "اسم العائلة",
  "Type the last name": "اكتب اسم العائلة",
  "Mobile phone number is required": "رقم الهاتف المحمول مطلوب",
  "Invalid mobile phone number": "رقم الهاتف المحمول غير صالح",
  "National ID is required": "الهوية الوطنية مطلوبة",
  "The national ID is invalid": "الهوية الوطنية غير صالحة",
  "Choose gender": "اختر الجنس",
  "The role": "الدور",
  "Select the role": "اختر الدور",
  "Add organizational units": "إضافة وحدات تنظيمية",
  "You are logged in from a new browser, please check your email for the OTP": "قمت بتسجيل الدخول من متصفح جديد، يرجى تفقد بريدك الإلكتروني لكلمة المرور الصالحة لمرة واحدة",
  "OTP": "(OTP) أدخل كلمة المرور الصالحة لمرة واحدة",
  "nothing new": "ﺗﺴﺠﻴﻞ اﻟﺪﺧﻮل",
  "Your account has been activated": "تم تفعيل حسابك",
  "Current password": "كلمة المرور الحالية",
  "Do you want to reset your password?": "هل تريد إعادة تعيين كلمة المرور ؟",
  "The update has been sent successfully": "تم إرسال التحديث بنجاح",
  "Search for pages that contain...": "البحث عن صفحات تشتمل على...",
  "Your browser does not support the video tag.": "متصفحك الحالي لا يدعم تشغيل الفيديو.",
  "Course Details": "تفاصيل الدورة",
  "Course title :": "عنوان الدورة :",
  "Course type :": "دورة كتابية :",
  "please select date in range": "يرجى تحديد التاريخ في النطاق",
  "Download file.pdf": "تحميل الملف.pdf",
  "Action": "خيارات أخرى",
  "Update": "تحديث",
  "is video": "هو الفيديو",
  "Location Link": "رابط المقر",
  "Graph Name": "اسم الرسم البياني",
  "Graph Type": "نوع الرسم البياني",
  "Organize data templates": "إدارة قوالب البيانات",
  "Organizing classifications": "إدارة التصنيفات",
  "Services": "الخدمات",
  "common questions": "الأسئلة الشائعة",
  "Economic activities": "الأنشطة الاقتصادية",
  "Closed cases": "حالات مغلقة",
  "Searching for a specific type of data?": "البحث عن نوع معين من البيانات؟",
  "If you are looking for services and their details, click the button below.": "إذا كنت تبحث عن خدمات وتفاصيلها ، انقر فوق الزر أدناه.",
  "If you are looking for FAQs that can help you better help customers. Click the button below.": "إذا كنت تبحث عن أسئلة شائعة التي يمكن أن تساعدك بشكل أفضل على مساعدة العملاء . اضغط على الزر أدناه.",
  "National Directory of Economic Activities (ISIC4)": "الدليل الوطني للأنشطة الاقتصادية (ISIC4)",
  "If you are looking for the National Directory of Economic Activities (ISIC4) that can better help you assist customers. Click the button below.": "إذا كنت تبحث عن الدليل الوطني للأنشطة الاقتصادية (ISIC4) التي يمكن أن تساعدك بشكل أفضل على مساعدة العملاء . اضغط على الزر أدناه.",
  "Take a look at past queries and solutions that helped our team.": "ألق نظرة على الاستفسارات السابقة والحلول التي ساعدت فريقنا.",
  "Organization type classification": "إدارة نوع التصنيف",
  "Types of organizational units": "أنواع الوحدات التنظيمية",
  "User console": "إدارة المستخدمين",
  "Organizing roles": "إدارة الأدوار",
  "Powers": "الصلاحيات",
  "Organization of powers": "إدارة الصلاحيات",
  "Create permissions": "إنشاءالصلاحيات",
  "Training Course": "الدورة التدريبية",
  "Types of training courses": "أنواع التدریب",
  "The end time cannot be before the start time": "لا يمكن أن يكون وقت الانتهاء قبل وقت البدء",
  "External Company": "شركة خارجية",
  "Register External Coordinator": "تسجيل منسق تدريب خارجي",
  "Company Trainers": "المدربين",
  "Company Details": "تفاصيل الشركة",
  "Add Trainer": "إضافة مدرب",
  "Add trainer": "إضافة مدرب",
  "Email": "البريد الإلكتروني",
  "Gender": "الجنس",
  "National ID": "الهوية الوطنية",
  "Phone Number": "رقم الهاتف المحمول",
  "Edit Trainer Details": "تحرير تفاصيل المدرب",
  "Edit Trainer": "تحرير المدرب",
  "Trainers": "المدربين",
  "Master Trainer": "المدرب الرئيسي",
  "Optional Trainer": "المدرب الاختياري",
  "Duplicate as Draft":"نسخ كمسودة",
  "Internal": "داخلي",
  "External": "خارجي",
  "Remove trainer": "إزالة مدرب",
  "Remove": "يزيل",
  "External Coordinator": "منسق تدريب خارجي",
  "Select compan": "اختر الشركة",
  "Upload attendance prove": "إضافة صورة",
  "Attendance prove": "كشف الحضور",
  "Please select a date within the course": "الرجاء تحديد تاريخ خلال الدورة",
  "Add Company": "إضافة شركة",
  "Update Company": "تحديث الشركة",
  "New Branch Training": "تدريب فرع جديد",
  "Add Questions": "أضف أسئلة",
  "Add Question": "أضف أسئلة",
  "Add Survey": "إضافة الاستبيان",
  "Upload Video": "رابط الفيديو",
  "Add recording link": "إضافة فيديو",
  "this icon not": "هذه الأيقونة لا تعمل يرجى إضافة أيقونة مخصصة",
  "Skill Training": "التدريب المهاري",
  "Revision": "المعتمدة",
  "Done With Revision": "تمت المراجعة",
  "Publish Details": "التفاصيل",
  "Self Registration": "تسجيل ذاتي",
  "Manager Registration": "تسجيل من قبل المدراء",
  "Select OU": "حدد الجهة الوظيفية",
  "publish": "نشر",
  "Suggested Courses": "الدورات التدريبية المتاحة",
  "Submit Request": "موافق",
  "Re-create": "Re-create",
  "Maximum number of attendees": "إجمالي عدد الحضور",
  "Month Already Assigned to Ou": "تم تحديد الشهر للفرع",
  "Select newly created branch": "حدد فرع جديد",
  "click on item to view details": "اختر أي من البيانات لعرض التفاصيل",
  "Content Related": "المحتوى",
  "Organisational Units": "الوحدة التنظيمية",
  "Organisational Structure": "الهيكل التنظيمي",
  "Branches": "الفروع",
  "Add": "إضافة",
  "Activate Data": "بيانات نشطة",
  "Activate": "تفعيل الحساب",
  "Deactivate Data": "إلغاء التنشيط",
  "Exclude these words from the search": "أن يستبعد هذه الكلمات من البحث",
  "Select city": "اختر المدينة",
  "Pending Attendees": "قائمة الانتظار",
  "Short of attendance": "غير المكتملة",
  "Training Dashbaord": "لوحة معلومات الدورة التدريبية",
  "total": "المجموع",
  "Mark Attendance": "تحديد الحضور ",
  "Redirect to home": "إذا كنت لا تريد إعادة تعيين كلمة المرور يمكنك الضغط هنا للعودة إلى الصفحة الرئيسية",
  "Add Question Bank": "إضافة مسار جديد",
  "Create a Question Bank": "إنشاء بنك الأسئلة",
  "Update Question Bank": "تحديث بنك الأسئلة",
  "DELETE": "حذف",
  "Total Records": "إجمالي البيانات",
  "Content Update Type": "النوع",
  "update requests": "تحديث المحتوى",
  "If you do not want to reset your password, you can click here to return to the home page": "الصفحة الرئيسية",
  "Can Not Create Any other user with this designation": "لا يمكن إضافة أي مستخدم آخر لهذا المسمى الوظيفي",
  "Are you sure you want to Accept this training?": "هل أنت متأكد من قبول هذا الطلب؟",
  "Are you sure you want to diactivate this task?": "هل أنت متأكد من تعطيل هذا الطلب؟",
  "Are you sure you want to activate this training?": "هل أنت متأكد من تفعيل هذا الطلب؟",
  "Training Workshops": "الورش التدريبية",
  "training course": "الدورات التدريبية",
  "training request completion": "طلبات استكمال الورش التدريبية",
  "Branch Details": "بيانات الفروع",
  "Completion Rate": "معدل الإنجاز",
  "Show Dashboard": "عرض لوحة التحكم",
  "Show List": "عرض المهام",
  "Are you sure you want to delete this request?": "هل أنت متأكد من حذف هذا الطلب؟",
  "Attendance Heading": "الحضور",
  "Start Date": "تاريخ البدء",
  "Start Date required": "تاريخ البدء مطلوب",
  "End Date required": "تاريخ الانتهاء مطلوب",
  "End Date": "تاريخ الانتهاء",
  "Data Limit": "حد البيانات",
  "results": "النتيجة",
  "Contact": "رقم الهاتف المحمول",
  "Status": "الحالة",
  "Mark Type": "نوع الحضور",
  "Marked At": "تاريخ الحضور",
  "Actions": "إجراء",
  "Survey Settings": "الإعدادات",
  "Display Mode": "عرض النمط",
  "Tag": "العلامة",
  "Select Tag": "حدد العلامة",
  "Tags Management": "إدارة العلامات",
  "Attachment for clarification": "مرفق أدناه صورة لتوضيح",
  "Image Chooser": "الصور",
  "Select One": "حدد واحدةً",
  "Select Many": "حدد العديد",
  "Graphical Rating": "مقياس التقييم",
  "Star Rating": "التقييم بالنجوم",
  "Smiley Rating": "التقييم بالوجوه والأشكال المبتسمة",
  "Basic Matrix": "سؤال المصفوفة",
  "Multi-Point Scales": "مصفوفة النقاط",
  "Multi-Select": "حدد العديد",
  "Ordering": "ترتيب",
  "Rank Order": "ترتيب الترتيب",
  "Drag and Drop": "السحب والإفلات",
  "Misc": "أخرى",
  "Date/Time": "التاريخ",
  "Calander": "التقويم",
  "Static Content": "المقالات الحرة",
  "Presentation Text": "نص العرض",
  "Section Heading": "العنوان",
  "Section Sub-Heading": "العنوان الفرعي",
  "Topics": "بنك الأسئلة",
  "New Topic": "سؤال عام جديد",
  "Service": "الخدمة",
  "Create a Topic": "إضافة سؤال عام جديد",
  "Tags": "العلامات",
  "Arabic": "الاسم",
  "Tag update": "تعديل",
  "Assessment name": "العنوان",
  "Grades": "سلم الدرجات",
  "Attendance": "الحضور",
  "Grades Criteria": "سلم الدرجات",
  "Grade Title": "التقدير",
  "Title": "العنوان",
  "From": "من",
  "To": "إلى",
  "Icon": "الأيقونة",
  "Create a new assessment": "إنشاء اختبار جديد",
  "Assessment": "الاختبارات",
  "assessment": "الاختبارات",
  "Assessments": "الاختبارات",
  "New Assessment": "اختبار جديد",
  "Survey Closed Error": "عذراً ، لا يمكن الوصول إلى الاستبيان",
  "Assessment Closed Error": "عذراً، لايمكن الوصول إلى الاختبار",
  "Start Tomorrow Assessment": "عذرًا، الاختبار لم يبدأ بعد",
  "Start Tomorrow Survey": "عذرًا، الاستبيان لم يبدأ بعد.",
  "Through Knowledge Portal Users": "لمستخدمين محددين",
  "BY_LINK": "للجميع",
  "Results": "النتائج",
  "seek": "يبحث",
  "Navigation page": "دليل الخدمات الحكومية",
  "Success! You have uploaded": "نجاح! لقد قمت بتحميل ",
  "The following are the missing types in the data. You can replace them with existing ones or add new ones from the dashboard.": "فيما يلي الأنواع الناقصة من البيانات. يمكنك استبدالها بالبيانات الموجودة أو يمكنك إضافة بيانات جديدة من لوحة التحكم.",
  "UpdateTraining": "تحديث",
  "House Number": "رقم الدار",
  "draft": "مسودة",
  "Publish": "نشر",
  "View": "معاينة",
  "Delete training": "حذف",
  "Edit": "تعديل",
  "Edit box":"تعديل",
  "Reject": "رفض",
  "Assign Users": "تحديد مستخدمين",
  "Select a Company": "اختر شركة خارجية",
  "Activate Training": "تفعيل",
  "Deactivate Training": "تعطيل الدورة التدريبية",
  "Create Training": "إنشاء دورة تدريبية",
  "Are you sure you want to pusblish this training": "هل أنت متأكد من أنك تريد نشر هذا؟",
  "Comfirm message heading": "رسالة التأكيد",
  "Reason Required": "السبب مطلوب",
  "DEACTIVATED": "المعطلة",
  "Number of sessions": "عدد الجلسات المسموحة في كل دورة التدریبیة",
  "allowed ou": "الوحدات التنظيمية المسموحة",
  "training type name in arabic": "الاسم باللغة العربية",
  "training type name": "الاسم باللغة الإنجليزية",
  "coordinator": "منسق التدريب",
  "website": "الموقع الإلكتروني",
  "Show Calender": "التقويم",
  "Add External Coordinator": "إضافة منسق خارجي",
  "Coordinators": "المنسقون",
  "Heading": "Heading",
  "View Revision": "المراجعة",
  "Add to Kl": "أضف لمكتبة المعرفة",
  "Recreate Training for Pending Users": "إعادة إنشاء التدريب للمستخدمين في قائمة الانتظار",
  "Related Services": "محتوى ذو صلة",
  "Generating... Please wait": "جارٍ الإنشاء... الرجاء الانتظار",
  "Create a directory": "إنشاء دليل",
  "download directory": "تحميل دليل",
  "Table of contents": "جدول المحتويات",
  "faq for print": "الأسئلة الشائعة على  خدمات",
  "service for print": "خدمات",
  "isic for print": "الأنشطة الاقتصادية ",
  "license for print": "تراخيص",
  "Print Items": "الإجمالي",
  "Select a training type": "حدد النوع",
  "training types": "نوع الدورة التدريبية",
  "Ou Management Page": "إدارة الجهات",
  "Activation Requests": "طلبات التفعيل",
  "User Informations": "الحسابات النشطة",
  "Deactivated Accounts": "الحسابات الغير نشطة",
  "Data Management": "إدارة البيانات",
  "Category Name": "اسم التصنيف",
  "Category Type": "نوع التصنيف",
  "Priority": "الأولوية",
  "Category Icons": "الايقونات",
  "Category Status": "الحالة",
  "Search...": "بحث...",
  "Entites Filter": "الفرز",
  "aljaha": "الجهة",
  "almastue alraise": "المستوى الرئيسى",
  "alkhidmat": "الخدمة",
  "almastuie alfaraie": "المستوى الفرعي",
  "Add Assessment": "إضافة اختبار",
  "Import": "استيراد",
  "Import Assessment": "استيراد اختبار",
  "Import Survey": "استيراد استبيان",
  "All categories": "كل الفئات",
  "No data": "لا توجد بيانات",
  "Edit Survey": "تحديث الاستبيان",
  "Edit Assessment": "تحديث الاختبار",
  "Block Coordinator": "حظر المشرف",
  "UnBlock Coordinator": "إلغاء الحظر",
  "Training Settings": "إعدادات التدریب",
  "Are you sure you waant to register in this course?": "هل أنت متأكد من أنك تريد التسجيل في هذا الدورة التدريبية؟",
  "Add Question from Topic": "إضافة سؤال",
  "Add Question to Topic and Assessment": "إضافة سؤال",
  "Select a topic": "حدد الموضوع",
  "Marks": "الدرجة",
  "-Select-": "اختر",
  "Row": "صف",
  "Column": "عمود",
  "Day": "اليوم",
  "Month": "الشهر",
  "Year": "السنة",
  "Select All": "تحديد الكل",
  "Invitees": "المشاركين",
  "Score / Total Marks": "الدرجة",
  "assessment Results": "نتائج الاختبارات",
  "survey Results": "نتائج استبيان",
  "Percentage": "النسبة",
  "Result": "التقدير",
  "Questions": "أضف سؤال جديد",
  "All Questions": "جميع الأسئلة",
  "Open Ended Questions": "الأسئلة المفتوحة",
  "Score": "الدرجة",
  "Select Service": "اختر خدمة",
  "Please Give Answer to all the Following Question": "يرجى الإجابة على هذا السؤال",
  "SINGLE_ROW_TEXT": "نص صف واحد",
  "EMAIL_ADDRESS": "عنوان البريد الإلكتروني",
  "COMMENT_BOX": "صندوق التعليقات",
  "CONTACT_INFO": "معلومات التواصل",
  "SELECT_ONE": "حدد واحدةً",
  "SELECT_MANY": "حدد العديد",
  "DROPDOWN_MENU": "القائمة المنسدلة",
  "SELECT_ONE_IMAGE": "حدد واحدةً",
  "SELECT_MANY_IMAGE": "حدد العديد",
  "STAR_RATING": "التقييم بالنجوم",
  "SMILE_RATING": "التقييم بالوجوه والأشكال المبتسمة",
  "MULTI_POINT_SCALE": "مصفوفة النقاط",
  "MULTI_SELECT_SCALE": "حدد العديد",
  "RANK_ORDER": "ترتيب الترتيب",
  "DRAG_DROP": "السحب والإفلات",
  "DATE_TIME": "التاريخ/ الوقت",
  "CALENDAR": "التقويم",
  "Calendar": "التقويم",
  "PRESENTATION_TEXT": "نص العرض",
  "SECTION_HEADING": "العنوان",
  "SECTION_SUB_HEADING": "العنوان الفرعي",
  "Start": "ابدأ",
  "Most active Branches and centers": "المراكز والفروع الأكثر نشاطاً",
  "number of workshops": "ورش تدريبية",
  "Most highlighted workshops": "أبرز موضوعات الورش",
  "Most highlighted Traninig": "أبرز موضوعات الدورات",
  "Completed Workshops": "إجمالي عدد الورش المكتملة",
  "Total number of completed trainings": "إجمالي عدد الدورات المكتملة",
  "Total number of trainings": "إجمالي عدد الدورات ",
  "Total Number of workshops": "إجمالي عدد الورش",
  "workshops total and completed": "إجمالي عدد الورش التدريبية وعدد الورش المكتملة",
  "training total and completd": "إجمالي عدد الدورات التدريبية وعدد الدورات التدريبية المكتملة",
  "Users added to waiting list": "تم إضافة المستخدم إلى قائمة الانتظار",
  "User Added to training": "تم إضافة المستخدم للدور التدريبية",
  "Previous Month": "الشهر السابق",
  "Next Month": "الشهر القادم",
  "Easy": "سهل",
  "Medium": "متوسط",
  "Hard": "صعب",
  "You have attempted this assessment": "لا يمكن أداء الاختبار أكثر من محاولة واحدة",
  "You have attempted this survey": "لا يمكن أداء استبيان أكثر من محاولة واحدة",
  "allowed_trainings": "الدورة التدريبية المسموحة",
  "Visit Calander": "التقويم",
  "View Attendance": "عرض الحضور",
  "Present": "حاضر",
  "Present Users:": "المستخدمون الحاضرون",
  "Absent": "غائب",
  "Did Not Attend": "لم يحضر",
  "Add Visit": "Add Visit",
  "Create Vendor": "الجهات المنفذة للمشروع",
  "Classification": "التصنيف",
  "Ms Internal": "داخلي",
  "Ms External": "خارجي",
  "Ms Location": "المقر",
  "PM Name": "اسم مدير المشروع",
  "PM Email": "البريد الإلكتروني لمدير المشروع",
  "PM Mobile": "رقم هاتف مدير المشروع",
  "Alternative PM Name": "اسم الشخص البديل",
  "Alternative PM Email": "البريد الإلكتروني للشخص البديل",
  "Alternative PM Mobile": "رقم هاتف الشخص البديل",
  "Vendor List": "الجهات المنفذة للمشروع",
  "Responsible": "المعنيين بالمشروع",
  "Mobile": "رقم الهاتف المحمول",
  "Create Project": "إنشاء مشروع",
  "Project name": "اسم المشروع",
  "Project description": "وصف المشروع",
  "Channels": "القناة",
  "Visits": "عدد الزيارات",
  "Measuring type": "أنواع الاوزان",
  "Project Goals": "أهداف المشروع",
  "Assign Weight for channels": "اوزان القنوات",
  "Weights": "اوزان القنوات",
  "Channels weight": "وزن القنوات",
  "Branches weight": "وزن الفروع",
  "Enquiries & Criteria’s": "المعايير والاستفسارات",
  "Main Criterias": "المعايير الرئيسية",
  "Sub Criterias": "المعايير الفرعية",
  "Sub Criteria": "المعايير الفرعية",
  "Factors": "المؤشرات",
  "Measuring Type": "أنواع الاوزان",
  "Visit Calendar": "جدول المواعيد",
  "Sunday": "الأحد",
  "Undo": "استرجاع الحساب",
  "Monday": "الإثنين",
  "Tuesday": "الثلاثاء",
  "Wednesday": "الأربعاء",
  "Thursday": "الخميس",
  "Friday": "الجمعة",
  "Saturday": "السبت",
  "Visit date and time": "تاريخ ووقت الزيارة",
  "Visit Schedule Approval": "اعتماد البيانات وجدول الزيارات",
  "Approve Comment": "التعليق",
  "Enquiries for the mystery shopper": "استعلامات المتسوق الخفي",
  "Enquire": "الاستعلام",
  "Correct Answer": "الإجابة الصحيحة",
  "Service URL": "رابط الخدمة",
  "Re-do": "إعادة العمل",
  "Forwarding": "توجيه الملاحظات",
  "List of factors": "قائمة المؤشرات",
  "Grade/5": "الدرجة/ 5",
  "Comments entered by eternal project manager": "ملاحظات مدير المشروع الخارجي",
  "Comments entered by internal project manager": "ملاحظات مدير المشروع الداخلي",
  "Challenge": "تحدي",
  "On-Hold": "معلق",
  "In-Progress": "قيد التنفيذ",
  "Visit time": "وقت الزيارة",
  "Enquires List": "قائمة الاستعلامات",
  "Employee Answer": "إجابة الموظف",
  "Approve comment": "ملاحظات المعتمد",
  "Factors List": "قائمة المؤشرات",
  "Mystery Shopper Comment": "ملاحظات المتسوق الخفي",
  "Responsible Comments": "ملاحظات المسؤول",
  "Responsible comments": "ملاحظات المسؤول",
  "Factor Status": "حالة المؤشر",
  "SBC Portal": "منصة المركز السعودي للتنافسية والأعمال",
  "Out of kingdom": "خارج المملكة",
  "In Kingdom": "داخل المملكة",
  "Total target of the project": "الهدف الإجمالي للمشروع",
  "Best IU Branches": "أفضل الفروع تقييماً",
  "Scope": "النطاق",
  "Unassigned Factors": "مؤشرات غير موجهة",
  "Are you sure you want to approve this factor?": "هل تريد بالتأكيد اعتماد انجاز هذا المؤشر؟",
  "Confirm": "تأكيد اعتماد",
  "Steps": "خطوات",
  "Step": "خطوة",
  "Channels Weight": "وزن القنوات",
  "Branches Weight": "وزن الفروع",
  "Weight": "الوزن",
  "Next": "التالي",
  "Criterias": "المعايير",
  "'(isUpdate? 'Update':'Create')'": "'(هل التحديث؟ 'تحديث':'إنشاء')'",
  "Add Channel": "إضافة قناة",
  "Channel Name": "اسم القناة",
  "Company Name": "اسم الشركة",
  "Project": "المشاريع",
  "error": "خطأ",
  "Please Enter Comments": "الرجاء إدخال التعليقات",
  "Channel with this name already exists": "القناة بهذا الاسم موجودة بالفعل",
  "Please Provide all Valid Data": "يرجى تعبئة جميع المعلومات",
  "Add Project": "إضافة مشروع",
  "Update Project": "تحديث المشروع",
  "Vendors": "الجهات المنفذة",
  "Vendor": "الجهات المنفذة",
  "Measuring Types": "أنواع القياس",
  "Project List": "قائمة المشاريع",
  "Main Criteria": "المعايير الرئيسية",
  "Channel": "القناة",
  "Criteria": "المعايير",
  "Project Name": "اسم المشروع",
  "Project Description": "وصف المشروع",
  "Internal PM": "مدير المشروع الداخلي",
  "External PM": "مدير المشروع الخارجي",
  "Create": "إنشاء",
  "Redo State": "إعادة تعيين",
  "Comment": "ملاحظة",
  "Name Required": "الاسم مطلوب",
  "Assign Weights": "التفاصيل",
  "Evaluation": "التقييم",
  "Factor Dashboard": "قائمة المؤشرات",
  "Factor Status Update": "إعادة العمل",
  "Factor Status Approve": "اعتماد الحالة",
  "Factors History - Reports": "سجل المؤشرات",
  "Enquiries": "الاستعلامات",
  "This Project have Approvals": "يحتوي هذا المشروع على موافقات",
  "This Project have Redos": "يحتوي هذا المشروع على طلبات إعادة العمل",
  "This Project have Pending Approvals": "يحتوي هذا المشروع على موافقات قيد الانتظار",
  "This Project have Pending Changes": "يحتوي هذا المشروع على طلبات تعديل",
  "are in Approved State": "تم اعتماد",
  "are in Redo State": "تم ارسال طلب لإعادة العمل",
  "are in Pending State": "قيد التنفيذ",
  "are in Change State": "قيد التعديل",
  "Request change": "طلب تعديل",
  "Select Vendor": "حدد الجهة المنفذة",
  "Select Internal PM": "حدد مدير المشروع الداخلي",
  "Factor cut %": "درجة تقييم المعيار 0-5",
  "Goal": "اكتب هدف المشروع هنا",
  "Senior": "المسؤول الأول",
  "Add Sessions": "إضافة موعد الزيارة",
  "Submit": "موافق",
  "SubmitMS": "ارسال",
  "Select Channel": "حدد قناة",
  "Please select a channel.": "يرجى تحديد القناة",
  "Please type a criteria.": "يرجى كتابة المعيار",
  "Users All ready assigned to some session at this moment": "قائمة المستخدمين الذين هم في جلسة تدريبية أخرى في الوقت الحالي",
  "Iteration": "Iteration",
  "canceled": "غير المكتملة",
  "Request Revision": "طلب مراجعة ",
  "Cancel training": "إلغاء الدورة التدريبية",
  "Select Branch": "حدد فرع",
  "Branch": "الفرع",
  "Factor": "المؤشرات",
  "Enquiry": "الاستعلام",
  "January": "يناير",
  "February": "فبراير",
  "March": "مارس",
  "April": "أبريل",
  "May": "مايو",
  "June": "يونيو",
  "July": "يوليو",
  "August": "أغسطس",
  "September": "سبتمبر",
  "October": "أكتوبر",
  "November": "نوفمبر",
  "December": "ديسمبر",
  "PM Comments": "ملاحظات مدير المشروع",
  "Select a session": "حدد الجلسة",
  "Enquries List": "قائمة الاستعلامات",
  "Approve": "اعتماد",
  "Approved": "تم الاعتماد",
  "Redo": "إعادة العمل",
  "Pending": "قيد الانتظار",
  "Change": "طلب تعديل",
  "Request Change": "طلب تعديل",
  "Not Submitted": "لم يتم الارسال",
  "Repeat": "التكرار",
  "Forward": "إعادة التوجيه",
  "Approval Status": "الحالة",
  "Redo Comments": "ملاحظات المتسوق الخفي",
  "View History": "عرض السجل",
  "Mystery Shopper": "المتسوق الخفي",
  "Sessions ": "الجلسات",
  "MSSessions": "مواعيد الزيارة",
  "Create Session": "إضافة جلسة",
  "Create MSSession": "إضافة موعد الزيارة",
  "Session Name": "اكتب الاسم هنا",
  "Session List": "قائمة الجلسات",
  "MSSession List": "قائمة مواعيد الزيارة",
  "(Visit per branch)": "(ادخل الزيارات على حسب الفروع)",
  "The total weight should be 100": "مجموع الوزن يجب أن يكون ١٠٠",
  "Visit Time": "موعد الزيارة",
  "Select a Visit": "اختر موعد الزيارة",
  "Dashboard-Reports": "التقارير _ لوحة البيانات",
  "SBC": "المركز السعودي للتنافسية والأعمال",
  "Grade of Each Branch": "أداء كل فرع",
  "Grade": "التقدير",
  "MSMarks": "التقدير",
  "Total": "الإجمالي",
  "Total Targets of the project": "إجمالي أهداف هذا المشروع",
  "Weightage": "الوزن",
  "Assessment Comments": "المقدمة",
  "Question Bank Heading": "المسارات",
  "Classic": "نمط عادي",
  "Focus": "نمط متنقل",
  "Submit Assessment": "إرسال",
  "Change in Service": "تم تحديث الخدمة",
  "ATTENDANCE_SHORT": "الفائتة",
  "Copy Link": "نسخ الرابط",
  "Auto Question": "توليد الأسئلة تلقائياً",
  "Feedback": "التغذية الراجعة",
  "Topic": "الموضوع",
  "Select Ministry": "حدد الجهة",
  "Select Type": "حدد النوع",
  "Standard Question Bank": "بنك الأسئلة العام",
  "Dedicated Question Bank": "بنك الأسئلة الخاص",
  "Update Topic": "تحديث الموضوع",
  "Select Topic": "حدد الموضوع",
  "Add Topic": "المجالات",
  "Create Topic": "المجالات",
  "Topic Name": "اسم الموضوع",
  "Topic List": "قائمة المجالات",
  "Show Standard Question Bank": "عرض بنك الأسئلة العام",
  "Automatic Question Generator": "توليد الأسئلة تلقائياً",
  "Any Topic": "أي موضوع",
  "Difficulty Level": "مستوى",
  "Any Difficulty Level": "أي مستوى",
  "Question Type": "نوع السؤال",
  "Any Question Type": "أي نوع",
  "No. of Question": "عدد الأسئلة",
  "Generate": "توليد",
  "Select User Type": "حدد نوع المستخدم",
  "Internal Users": "مستخدم داخلي",
  "External Users": "مستخدم خارجي",
  "General information about the assessment": "البيانات العامة للاختبار",
  "General information about the survey": "بيانات عامة الاستبيان",
  "Knowledge gate": "ﺑﻮاﺑﺔ اﻟﻤﻌﺮﻓﺔ",
  "Development": "التطوير",
  "Select Measuring Type": "حدد نوع الوزن",
  "Rating": "الدرجة من 5",
  "Yes, No": "لا, نعم",
  "True, False": "صح, خطأ",
  "Log out": "تسجيل خروج",
  "Profile personly": "الملف الشخصي",
  "Homepage": "الصفحة الرئيسية",
  "Notifications": "إشعارات ",
  "All caught up": "تمت قراءة جميع الإشعارات",
  "Unread": "غير مقروء",
  "Read": "مقروء",
  "showAll": "اظهار الكل",
  "markAllRead": "تعيين الكل كمقروء",
  "To know": "المعرفة",
  "Brother searches": "عمليات البحث الأخيرة",
  "Discus": "بحث",
  "advanced search": "بحث متقدم",
  "sort by": "ترتيب حسب",
  "Name of the entity or ministry": "اسم الكيان أو الوزارة",
  "Search for entities and ministries": "ابحث عن الكيانات والوزارات",
  "All entities and ministries": "جميع الكيانات والوزارات",
  "Ministries": "الوزارات",
  "Other entities": "كيانات أخرى",
  "the detail": "التفاصيل",
  "search": "بحث",
  "species": "الأنواع",
  "the cities": "المدن",
  "Create a type": "إنشاء نوع",
  "Create an organizational unit": "إنشاء الوحدة التنظيمية",
  "success": "نجاح",
  "Success": "نجاح",
  "Add a new city": "إضافة مدينة جديدة",
  "City update": "تحديث المدينة",
  "Create a category": "إنشاء تصنيف",
  "Update classification": "تحديث التصنيف",
  "Update type": "تحديث النوع",
  "Update user data": "تحديث بيانات المستخدم",
  "Disable account": "تعطيل حساب",
  "Classification of entity services": "تصنيف خدمات الجهة",
  "Reset": "إعادة تعيين",
  "amendment": "تعديل",
  "Delete": "حذف",
  "Approval update": "إتاحة للمستثمرين",
  "Update content": "تحديث محتوى",
  "Settings": "الإعدادات",
  "Months": "أشهر",
  "Validity": "الصلاحية",
  "This service": "هذه الخدمة",
  "Search for a name or number": "ابحث عن اسم أو رقم",
  "There is no data": "لاتوجد بيانات",
  "Log filter": "التعليقات",
  "cancellation": "إلغاء",
  "Acceptance": "قبول",
  "to reject": "رفض",
  "comment": "التعليق",
  "Saudi": "السعودي",
  "Commercial registry services for institutions": "خدمات السجل التجاري للمؤسسات",
  "commercial register": "السجل التجاري",
  "Comments": "التعليقات",
  "Are you sure you want to approve this comment?": "هل أنت متأكد أنك تريد الموافقة على هذا التعليق؟",
  "Data classification": "إدارة التصنيفات",
  "Types of classifications": "إدارة أنواع التصنيفات",
  "data templates": "إدارة قوالب البيانات",
  "data types": "إدارة أنواع البيانات",
  "data": "البيانات",
  "Are you sure you want to do this?": "هل أنت متأكد من رغبتك بفعل هذا؟",
  "Are you sure you want to delete this report": "هل أنت متأكد أنك تريد حذف هذا التقرير؟",
  "ç": "خطأ",
  "Error": "خطأ",
  "Ministry of Commerce": "وزارة التجارة",
  "Training": "التدريب",
  "Knowledge": "المعرفة",
  "sign in": "تسجيل الدخول",
  "Don't have an account?": "ليس لديك حساب؟",
  "Create an account": "إنشاء حساب",
  "E-mail": "البريد الإلكتروني",
  "password": "كلمة المرور",
  "Forgot your password ?": "نسيت كلمة المرور ؟",
  "One-time password": "كلمة المرور لمرة واحدة",
  "Password Reset": "إعادة تعيين كلمة المرور",
  "New Password": "كلمة المرور الجديدة",
  "Confirm the new password": "تأكيد كلمة المرور الجديدة",
  "Password creation requirements": "متطلبات إنشاء كلمة المرور",
  "Password match": "تطابق كلمة المرور",
  "At least 8 characters": "لا تقل عن 8 أحرف",
  "One uppercase letter (at least)": "حرف كبير واحد (على الأقل)",
  "One lowercase letter (at least)": "حرف صغير واحد (على الأقل)",
  "One number (at least)": "رقم واحد (على الأقل)",
  "One special code (at least)": "رمز خاص واحد (على الأقل)",
  "Forgot your password": "نسيت كلمة المرور",
  "do you have an account?": "هل لديك حساب؟",
  "OK": "موافق",
  "Knowledge portal": "ﺑﻮاﺑﺔ اﻟﻤﻌﺮﻓﺔ",
  "Knowledge Library": "مكتبة المعرفة",
  "Categories": "التصنيفات",
  "Add new data": "إضافة بيانات جديدة",
  "You can add more information by clicking the button below": "يمكنك إضافة المزيد من المعلومات من خلال الضغط على الزر أدناه",
  "Press here": "اضغط هنا",
  "Open in new tab": "فتح في علامة تبويب جديدة",
  "Interface update": "تحديث الواجهة",
  "Confirmation message": "رسالة التأكيد",
  "Do you want to delete this category or do you want to move the data to another category?": "هل تريد أن تحذف هذا التصنيف أو تريد أن تنقل البيانات لتصنيف آخر؟",
  "Transfer data to another classification": "نقل البيانات لتصنيف آخر",
  "Delete this category and data": "حذف هذا التصنيف و البيانات",
  "Back": "رجوع",
  "A new addition": "إضافة جديدة",
  "Content update logs": "سجلات تحديث المحتوى",
  "filter": "فلتر",
  "the condition": "الحالة",
  "Services filter": "فلتر الخدمات",
  "Type": "النوع",
  "starting date": "تاريخ البدء",
  "Expiry date": "تاريخ الانتهاء",
  "Content update requests": "تحديث المحتوى",
  "Release": "تحديث ",
  "Update address": "تحديث العنوان",
  "Add file": "إضافة ملف",
  "User updates": "تحديثات المستخدم",
  "Management updates": "تحديثات الإدارة",
  "Update Assessment": "تحديث الاختبار",
  "delete": "إلغاء الأمر",
  "Delete request": "طلب حذف",
  "Add data": "إضافة البيانات",
  "Update from management": "تحديث من الإدارة",
  "Change classification": "تغيير التصنيف",
  "Before updating": "قبل التحديث",
  "After the update": "بعد التحديث",
  "the reason of refuse": "سبب الرفض",
  "Are you sure you want to decline the update request?": "هل أنت متأكد أنك تريد رفض طلب التحديث؟",
  "Request before": "طلب من قبل",
  "Approved by": "الموافقة من قبل",
  "Rejected before": "الرفض من قبل",
  "approval date": "تاريخ الاسترداد",
  "Date of rejection": "تاريخ الرفض",
  "Content before update": "المحتوى قبل التحديث",
  "This service was updated more recently. Applying this request may overwrite newer changes. Do you want to continue?": "تم تحديث هذه الخدمة مؤخراً. الموافقة على هذا الطلب قد تستبدل التحديثات الأحدث. هل تريد المتابعة؟",
  "Choose a file": "اختيار ملف",
  "Choose the Excel file you want to download": "قم باختيار ملف الاكسل الذي تريد تحميله",
  "Download template": "تنزيل القالب",
  "You can use Scratch to upload data": "يمكنك استخدام المسودة لتحميل البيانات",
  "Template title": "عنوان القالب",
  "before": "من قبل",
  "the date": "التاريخ",
  "date": "التاريخ",
  "Entities": "الجهات",
  "Entity Name": "اسم الجهة",
  "Select Enitites": "حدد الجهة",
  "Named": "المسمى",
  "Sublevel": "المستوى الفرعي",
  "Basic level": "المستوى الأساسي",
  "Do you want to change the organizational unit?": "هل تريد التغيير في الوحدة التنظيمية؟",
  "ID": "بطاقة تعريف",
  "Image/icon": "صورة/ أيقونة",
  "Icons": "الايقونات",
  "Category": "التصنيف",
  "download": "تحميل",
  "Uploading Data": "رفع البيانات",
  "The uploaded data's categories have been added to the portal. Click on the button below to generate data and identify any missing fields.": "تمت إضافة فئات البيانات التي تم تحميلها إلى البوابة. انقر فوق الزر أدناه لإنشاء البيانات وتحديد أي حقول مفقودة.",
  "Missing fields": "الحقول الناقصة",
  "Imperfect species": "الأنواع الناقصة",
  "Assignment to another data type": "حدد نوع آخر من البيانات",
  "Draft name": "اسم المسودة",
  "The draft has been saved successfully.": "تم حفظ المسودة بنجاح",
  "Data name": "اسم البيانات",
  "Data Items": " البيانات",
  "Select an item from the list to view details.": "حدد عنصرًا من القائمة لعرض التفاصيل.",
  "Load data file": "تحميل ملف بيانات",
  "Location": "موقع",
  "Riyadh": "الرياض",
  "grandmother": "جدة",
  "Mecca": "مكة",
  "City": "المدينة",
  "Al Mubarraz": "المبرز",
  "Taif": "الطائف",
  "Tabuk": "تبوك",
  "organizational unit": "وحدة التنظيم",
  "Parent OU": "الوحدة التنظيمية الأم",
  "Organizational unit name": "اسم الوحدة التنظيمية",
  "Participating entities": "الجهات المشاركة",
  "Organizational unit class name": "اسم فئة الوحدة التنظيمية",
  "type": "يكتب",
  "Active": "نشيط",
  "Search Within": "البحث عن",
  "Pages include": "صفحات تشتمل على",
  "All these words": "كل هذه الكلمات",
  "It contains all these words": "أن يحتوي على جميع هذه الكلمات",
  "This whole word or phrase": "هذه الكلمة أو العبارة بالكامل",
  "Exactly matches this word or phrase": "أن يطابق تمامًا هذه الكلمة أو العبارة",
  "Any of these words:": "أي كلمة من هذه الكلمات",
  "Includes any of these words": "أن يتضمن أي كلمة من هذه الكلمات",
  "Narrow your results by...": "تضييق نتائج البحث حسب:",
  "Data type": "نوع البيانات",
  "Select type": "حدد النوع",
  "Select a type to narrow your search results": "حدد نوع البيانات لتضييق نتائج البحث",
  "The side": "الجهة",
  "Select a destination to narrow your search results": "حدد الجهة لتضييق نتائج البحث",
  "Search categories...": "البحث في التصنيفات...",
  "There are no ratings.": "لا توجد تصنيفات.",
  "None of these words": "لا شيء من هذه الكلمات",
  "Workshop": "ورشة عمل",
  "a test": "اختبار",
  "reconnaissance": "استبيان",
  "general information": "معلومات عامة",
  "Create Course": "إنشاء دورة",
  "Are you sure you want to approve this comment?": "هل أنت متأكد أنك تريد الموافقة على هذا التعليق؟",
  "Are you sure you want to publish this training?": "Are you sure you want to publish this training?",
  "Are you sure you want to delete?": "هل أنت متأكد أنك تريد حذف؟",
  "completed": "المكتملة",
  "COMPLETED": "المكتملة",
  "current": "الحالية",
  "pending": "قيد الانتظار",
  "PENDING": "قيد الانتظار",
  "Submit filter": "موافق",
  "Recent searches": "عمليات البحث الأخيرة",
  "If there are any comments, write your comment": "في حال وجود ملاحظات، اكتب تعليقك",
  "send": "إرسال",
  "Last updated": "آخر تحديث",
  "Select a service": "حدد الجهات/ التصنيفات",
  "to update": "تحديث",
  "Not approved by the expert": "تم الغاء الإتاحة للمستثمرين",
  "Approved by the expert": "تمت الإتاحة للمستثمرين من قبل الخبير",
  "the details": "التفاصيل",
  "from": "من",
  "The address": "العنوان",
  "training name": "اسم الدورة التدریبیة",
  "Name": "العنوان",
  "KL Description": "ادخل الوصف",
  "Created By": "تم الإنشاء من قبل",
  "KL File": "تم إضافة الملف",
  "KL Image": "حدد صورة",
  "KL category": "حدد تصنيف",
  "KL OU": "الوحدة التنظيمية",
  "Data is required": "البيانات مطلوبة",
  "Saudi Business Center": "المركز السعودي للتنافسية والأعمال",
  "Home": "بيت",
  "UI Components": "مكونات واجهة المستخدم",
  "Form Layout": "تخطيط النموذج",
  "Input": "مدخل",
  "Float Label": "الاسم العائمة",
  "Invalid State": "حالة غير صالحة",
  "Button": "زر",
  "Table": "طاولة",
  "List": "قائمة",
  "Tree": "شجرة",
  "Panel": "لوحة",
  "Overlay": "تراكب",
  "Media": "وسائط",
  "Menu": "قائمة طعام",
  "Message": "رسالة",
  "File": "ملف",
  "Chart": "جدول",
  "Dashboard": "لوحة المعلومات",
  "Prime Blocks": "كتل رئيس الوزراء",
  "Free Blocks": "كتل مجانية",
  "All Blocks": "جميع الكتل",
  "ALL": "الكل",
  "Questions Print": "أسئلة",
  "Assessments Question Bank": "بنك أسئلة الاختبارات",
  "Number of questions": "عدد الأسئلة",
  "Ministry is required": "الجهة مطلوبة",
  "Count is required": "عدد الأسئلة مطلوبة",
  "Select Items to view options": "حدد العناصر لعرض الخيارات",
  "Add Standard Question Bank": "بنك الأسئلة العام",
  "Please fill in the missing details for your account": "يرجى إكمال المعلومات الناقصة",
  "⁠Number of types of Assessments": "عدد نماذج الاختبـــارات",
  "⁠Number of types of Surveys": "عدد نماذج الاستبيانات",
  "Number of types of Assessments": "عدد نماذج الاختبـــارات",
  "Number of types of Surveys": "عدد نماذج الاستبيانات",
  "Number of Assessments": "عــــــــــــــــــدد الاختبارات",
  "Number of Surveys": "عدد الاستبيانات",
  "The Number of Questions": "إجمالي عدد الأسئلة",
  "Minimum number of questions in an assessment": "الحد الأدنى لأسئلة الاختبار",
  "Minimum number of questions in an survey": "الحد الأدنى لأسئلة الاستبيان",
  "Total number of who attempted": "إجمالي عدد المختبرين",
  "KGate registered users who attempted": "إجمالي عدد المختبرين المسجلين على بوابة المعرفة",
  "Internal Attendees who attempted": "المسجلين في بوابة المعرفة",
  "External Attendees  who attempted": "غير المسجلين في بوابة المعرفة",
  "Total Attendees": "إجمالي عدد المرشحين للاختبار",
  "Internal Attendees": "المسجلين في بوابة المعرفة",
  "External Attendees": "غير المسجلين في بوابة المعرفة",
  "Total number of who missed": "الفاقد من اجمالي المختبرين",
  "Overall performance level as estimated": "مستوى الأداء العام حسب التقدير",
  "Forms": "نماذج",
  "AUTO_SIGNED": "تم التوقيع تلقائيًا",
  "Assessment Attendees": "مختبر",
  "Assessment Question": "سؤال",
  "A comparison between the overall average number of correct answers and incorrect answers": "مقارنة بين المعدل العام لعدد الإجابات الصحيحة والإجابات الخاطئة",
  "Experiment": "مُخْتَبَر",
  "Average correct answers": " الاجابات الصحيحة",
  "Average incorrect answers": " الاجابات الخاطئة",
  "Total correct answers for all tests": "إجمالي الإجابات الصحيحة لجميع الاختبارات",
  "Average response rate to legislative questions": "معدل إجابات الأسئــــلـــــــــة التشريعــــيــة",
  "Average response rate to procedural questions": "معدل إجابات الأسئــــلـــــــــة الإجرائــيــــــــة",
  "Download": "تحميل",
  "Of the total testers made a mistake in the related procedure": "من إجمالي المشاركين أخطأوا في السؤال",
  "the total testers made a mistake in the related procedure": "إجمالي المشاركين أخطأوا في السؤال",
  "testers information": "معلومات المختبرين",
  "testers information Survey": "معلومات المشاركين في الاستبيان",
  "Ministries/Entities": "الجهات",
  "Tags to show in dropdown (attempt side)": "العلامات المعروضة في القائمة (جانب المحاولة)",
  "Select tags for attempt dropdown": "اختر العلامات لقائمة المحاولة",
  "click here": "إذا لم تصل لك رسالة التفعيل أضغط هنا",
  "Invalid Key": "غير صالح",
  "Link copied to clipboard": "تم نسخ الرابط بنجاح",
  "Print": "الطباعة",
  "User activated successfully": "تم تفعيل المستخدم بنجاح",
  "User deactivated successfully": "تم إلغاء تفعيل المستخدم بنجاح",
  "Unified Training Created Successfully": "Unified Training Created Successfully",
  "select date": "حدد المدة الزمنية",
  "The Date Has Passed": "لا يمكنك اختيار هذا اليوم",
  "Please select a date other than Friday or Saturday": "يرجى اختيار يوم غير يوم الجمعة ويوم السبت",
  "invalid Date select in current week": "invalid Date select in current week",
  "invalid Date select in assigned Month": "الاختيار غير صالح. يرجى الاختيار من شهر",
  "password is not allowed to be empty": "يجب عليك إدخال كلمة المرور",
  "email is not allowed to be empty": "يجب عليك إدخال البريد الإلكتروني",
  "email must be a valid email": "البريد الإلكتروني الذي أدخلته غير صالح، يرجى التحقق من عنوان بريدك الإلكتروني وإعادة المحاولة",
  "Session Title": "عنوان الجلسة التدريبية",
  "End Time": "وقت الانتهاء",
  "Enter Address": "اكتب عنوان المقر",
  "Link required": "الرابط مطلوب",
  "Trainer required": "المدرب مطلوب",
  "update trainer": "تحديث المدرب",
  "end time is required": "وقت الانتهاء مطلوب",
  "start time is required": "وقت البدء مطلوب",
  "Session Title is required": "عنوان الجلسة التدريبية مطلوب",
  "Date is Required": "التاريخ مطلوب",
  "Update Session": "تحديث الجلسة التدريبية",
  "Write": "رابط المصادر",
  "Upload": "إضافة",
  "URL Title": "الصق الرابط هنا",
  "Url": "الرابط",
  "Trainer is not available at this time": "المدرب غير متوفر في هذا الوقت",
  "Address Required": "عنوان المقر مطلوب",
  "Update Training": "تحديث الدورة التدريبية",
  "Date Filter": "فلتر التاريخ",
  "Select company": "حدد شركة",
  "Auto Rejection due to week change": "الرفض التلقائي بسبب تغير الأسبوع",
  "Enter Start Time": "Enter Start Time",
  "Enter Session URL": "الصق الرابط هنا",
  "Session Url is Required": "الرابط مطلوب",
  "Enter Location Link": "الصق رابط المقر هنا",
  "Please provide session date and time to assign trainer": "يرجى إضافة التاريخ والوقت لتحديد المدرب",
  "Video is not uploaded and no url found": "لم يتم تحميل الفيديو ولم يتم العثور على الرابط",
  "Unsupported Type": "Unsupported Type",
  "User added in an training": "User added in an training",
  "Due to multiple invalid Password reasons": "نظراً لأسباب متعددة كلمة مرور غير صحيحة",
  "Add Material": "إضافة مصادر",
  "Upload File": "تحميل ملف",
  "A Name": "الاسم",
  "write name here": "اكتب الاسم هنا",
  "Session Url": "الرابط",
  "Preview status": "معاينة",
  "Block status": "مغلق",
  "Unblock status": "مفتوح",
  "comment result": "التعليقات",
  "video url": "رابط مقطع الفيديو",
  "upload video": "تحميل مقطع الفيديو",
  "Create Survey": "إنشاء استبيان",
  "Create Assessment": "إنشاء اختبار",
  "Training Calender": "تفاصيل التقويم",
  "Upcoming": "القادمة",
  "Others": "أخرى",
  "Update Vendor": "تحديث الجهات المنفذة للمشروع",
  "Update MS Session": "تحديث موعد الزيارة",
  "Sessions": "الجلسات",
  "MS Session Name": "اكتب العنوان هنا",
  "Project Details": "تفاصيل المشروع",
  "By Weightage": "حسب الوزن",
  "Factors Table": "قائمة المؤشرات",
  "Sub Criteria Grade %": "نسبة المعايير الفرعية",
  "Criteria Grade %": "نسبة المعايير الرئيسية",
  "KL approval": "طلبات مكتبة المعرفة",
  "Calender View": "التقويم",
  "List View": "القائمة",
  "You have received a training request.": "لقد استلمت طلب دورة تدريبية",
  "You have been added to continuous training.": "تم إضافتك للتدريب المستدام",
  "New branch training has been created.": "تم إنشاء دورة تدريب فرع جديد",
  "You have been added to a new branch training.": "تم إضافتك لدورة تدريب فرع جديد",
  "A new training has been created for you to publish.": "تم إنشاء دورة تدريبية جديدة للنشر",
  "You have received a new training for your ou.": "لقد أستلمت دورة تدريبية جديدة لوحدتك التنظيمية",
  "A new training is available for you to register": "دورة تدريبية جديدة متاحة للتسجيل",
  "This training has been cancelled": "تم إلغاء الدورة التدريبية",
  "Data Update": "تم تحديث البيانات",
  "Content Approval Request": "تم استلام طلب الموافقة على محتوى جديد",
  "User Registered": "تم تسجيل مستخدم جديد",
  "New Comment": "تم إضافة تعليق جديد على خدمة",
  "Comment Replied": "تم الرد على تعليقك على خدمة",
  "New Knowledge Library": "إضافة جديدة لمكتبة المعرفة",
  "New Survey Assigned": "تم إنشاء استبيان",
  "Assessment Assigned": "تم إنشاء اختبار",
  "Send Alert": "إرسال إشعار",
  "Alert Message": "رسالة إشعار",
  "statistics of each question of the test": "تحليل النتائج على مستوى الأسئلة",
  "statistics of each question of the assessment": "تحليل النتائج على مستوى الأسئلة",
  "statistics of each question of the survey": "تحليل النتائج على مستوى الأسئلة",
  "statistics": "إحصائية الخبراء",
  "Show All Data": "عرض جميع البيانات",
  "Click here to start the exam": "ابدأ الاختبار",
  "Click here to start the survey": "لبدأ الاستبيان",
  "Survey already attempted": "تم الانتهاء من هذا الاستبيان",
  "Assessment already attempted": "تم الانتهاء من هذا الاختبار",
  "allowedAttempts": "عدد المحاولات المسموح بها",
  "User not in Course": "المستخدم غير موجود في الدورة التدريبية",
  "Please Select an assessment": "يرجى تحديد اختبار",
  "Please Select a survey": "حدد استبيان",
  "Status: Pass": "الحالة: مجتاز",
  "Status: Fail": "الحالة: غير مجتاز",
  "Number Of Attempts": "عدد المحاولات",
  "Recreate": "كرر",
  "Please Select Correct Answers of Following Questions": "يرجى تحديد الاختيار الصحيح",
  "Please Add Question Text & Option Label of Following Questions": "يرجى التأكد من إضافة السؤال الرئيسي والأسئلة الفرعية",
  "Total Marks": "مجموع درجات الاختبار",
  "Sum of Questions Marks are not Equal to Total Marks": "إجمالي درجات الأسئلة لا يساوي إجمالي الدرجات",
  "Self Register Manager Approval": "تسجيل من قبل المدراء (ظاهرة للموظفين)",
  "Maximum number of attendees form OU": "إجمالي عدد الحضور من كل جهة",
  "Request Course": "تسجيل",
  "You have received a request to add to the course": "لقد استلمت طلب الإضافة للدورة التدريبية",
  "DefaultManagerName": "{اسم المدير}",
  "DefaultPartnerName": "شريك معتمد لشركة {اسم الشريك}",
  "AttendanceCertGrettingMale": "الأستاذ",
  "AttendanceCertGrettingFemale": "الأستاذة",
  "AttendanceCertHazorMale": "حضر",
  "Start from": "من صفح",
  "AttendanceCertHazorFemale": "حضرت",
  "AttendanceCertLahamMale": "له",
  "AttendanceCertLahamFemale": "لها",
  "Certificate without Ministry Questions": "شهادة دون أسئلة الجهات",
  "Certificate with Ministry Questions": "شهادة عن أسئلة الجهات",
  "Certificate text1": "نص الشهادة 1",
  "Certificate text2": "نص الشهادة 2",
  "Certificate text3": "نص الشهادة 3",
  "Certificate text4": "نص الشهادة 4",
  "Certificate text5": "نص الشهادة 5",
  "Add Certificate": "إضافة شهادة",
  "Update Certificate": "تحديث الشهادة",
  "Certificate Bottom 1 Text": "نص الشهادة السفلي 1",
  "Certificate Bottom 2 Text": "نص الشهادة السفلي 2",
  "Certificate Bottom 3 Text": "نص الشهادة السفلي 3",
  "Upload Logo Image": "تحميل صورة الشعار",
  "Upload Signature Image": "تحميل صورة التوقيع",
  "Enter Manager Name": "أدخل اسم المدير",
  "Enter Partner Name": "أدخل اسم الشريك",
  "Shahadat": "شهادة",
  "Hazoor": "حضـــــــــــــــور",
  "Rating Surveys Settings": "إعدادات التقييم",
  "Rating Surveys": "استبيان التقييم",
  "Trainers Rating": "تقييم المدربين",
  "User Rating": "تقييم المتدربين",
  "Select Trainers": "حدد المدربين",
  "Please Select Required Data": "يرجى تحديد البيانات المطلوبة",
  "Conditional": "شرطي",
  "Select Question": "حدد سؤالا",
  "Select Option": "حدد خياراً",
  "No data found": "لا توجد بيانات",
  "You are not allowed for rating": "لا يسمح لك بالتقييم",
  "Failed to fetch rating status": "فشل في عرض حالة التقييم",
  "Give Rating": "قيّم",
  "SESSION": "الجلسات التدريبية",
  "Onsite": "حضوري",
  "DATES": "المدة الزمنية",
  "Online": "اون لاين",
  "View Details": "عرض التفاصيل",
  "Your request for the course is send to the manager": "تم ارسال طلب الانضمام لدورة للتدريبية إلى المدير",
  "Is Request": "الحالة",
  "Total number of users that can be assigned are :": "الحد المسموح لإضافة مستخدمين:",
  "Manager": "اختر المدير",
  "Manager OUS": "الوحدة التنظيمية للمدير",
  "Certificate": "شهادة",
  "Managers": "المدراء",
  "Non Managers": "أخرى",
  "Certificate Default": "<h1><strong>شهادة إتمام</strong></h1><p><br></p><p>تقر هذه الشهادة أن <strong> {اسم} </strong> أكملت بنجاح دورة&nbsp;<strong>{اسم التدريب}</strong></p>",
  "Write Text": "اكتب النص هنا",
  "Text": "النص",
  "Please enter your text below:": "يرجى إدخال النص في الحقل أدناه:",
  "You can use the rich text editor below to format your content. You can add headings, bold text, italic text, lists, links, and more. The editor supports various formatting options to help you create well-structured content.": "يمكنك استخدام محرّر النصوص لتنسيق المحتوى بالطريقة التي تناسبك. يتيح لك المحرّر إضافة العناوين، وتنسيق النصوص، وإدراج القوائم، والروابط، وغيرها من العناصر. كما يوفّر لك خيارات تنسيق متنوعة تساعدك على إعداد مادة تدريبية منظمة وواضحة وسهلة المتابعة.",
  "Upload training materials:": "رفع المواد التدريبية:",
  "You can upload files such as PDFs, documents, images, presentations, and other training materials. Supported formats include common file types. Once uploaded, these materials will be available for participants to download and view during the training session.": "يمكنك رفع الملفات التدريبية مثل ملفات PDF، والمستندات، والصور، والعروض التقديمية، وغيرها من المواد الداعمة. يدعم النظام أغلب صيغ الملفات الشائعة، مما يسهّل عليك إضافة كل ما يحتاجه المتدربون. بمجرد رفع الملفات، ستصبح متاحة للمشاركين لتنزيلها والاطلاع عليها.",
  "Add external link or video URL:": "إضافة رابط خارجي أو رابط فيديو:",
  "You can add links to external resources such as videos (YouTube, Vimeo), documents, websites, or any other online content. Simply paste the full URL in the field below. The system will automatically process video links and make them available for participants to view during the training session.": "يمكنك إضافة روابط لمقاطع الفيديو التدريبية مثل (Vimeo) أو المستندات والمواقع الإلكترونية أو أي محتوى آخر متوفر عبر الإنترنت. ما عليك سوى إدخال الرابط الكامل في الحقل المخصص، وسيقوم النظام بمعالجته تلقائيًا. بعد ذلك ستصبح روابط التدريب متاحة للمشاركين للاطلاع عليها.",
  "Material updated successfully": "تم تحديث المادة بنجاح",
  "Session updated successfully": "تم تحديث الجلسة بنجاح",
  "Failed to update session": "فشل تحديث الجلسة",
  "An error occurred while updating session": "حدث خطأ أثناء تحديث الجلسة",
  "Failed to update material": "فشل تحديث المادة",
  "An error occurred while updating material": "حدث خطأ أثناء تحديث المادة",
  "Add video content for this session:": "إضافة محتوى فيديو لهذه الجلسة:",
  "You can add video content in two ways: paste a video URL (from video platforms) in the 'Video URL' tab, or upload a video file directly using the 'Upload Video' tab. Once added, the video will be available for viewing during the training session.": "يمكنك إضافة محتوى فيديو بطريقتين: لصق رابط فيديو (من منصات الفيديو) في علامة التبويب 'رابط الفيديو' أو رفع ملف فيديو مباشرةً باستخدام علامة التبويب 'رفع فيديو'. بعد الإضافة، سيكون الفيديو متاحًا للمشاهدة أثناء جلسة التدريب.",
  "Request Received": "تم استلام الطلب",
  "No Request": "لا يوجد طلب",
  "Open Results": "عرض النتائج",
  "assessment date passed": "لقد انتهى موعد الاختبار",
  "survey date has passed": "لقد انتهى موعد الاستبيان",
  "General information about the Training": "معلومات عامة عن الدورات التدريبية",
  "Training Attendees": "عدد الحضور ",
  "Completed by Attendees": "المكتملة",
  "Average Percentage": "متوسط النسبة",
  "Training Grade": "التقدير",
  "Range": "توزيع الدرجات",
  "Training Users": "نسبة المستخدمين",
  "Password requirements not met": "لم يتم استيفاء متطلبات كلمة المرور",
  "Question": "السؤال",
  "Answer": "الجواب",
  "Managers of": "مدراء",
  "Branch is required": "الفرع مطلوب",
  "Rate Attendees": "قيم الحضور",
  "Rating Submitted Successfully!": "تم ارسال التقييم بنجاح",
  "Rate Trainer": "قيم المدربين",
  "Select Master Trainer": "حدد المدرب الرئيسي",
  "Certificate Text": "نص الشهادة",
  "Certificate Top Text": "النص العلوي للشهادة",
  "Certificate Middle Text": "النص الأوسط للشهادة",
  "Certificate Bottom Text": "النص السفلي للشهادة",
  "View Certificate": "عرض الشهادة",
  "Select Grade": "حدد الدرجة",
  "Assessment Certificate": "شهادة الاختبار",
  "DefaultCertificateTop": "{ذكر | أنثى } / {الاسم}",
  "DefaultCertificateMiddle": "نبارك لكم اجتيازكم للاختبارالمهاري في برنامج \n {اسم الاختبار}، وذلك بتقدير",
  "DefaultCertificateBottom": "متمنّين لكم مزيداً من التقدم والنجاح",
  "CertGrettingMale": "الزميل العزيز",
  "CertGrettingFemale": "الزميلة العزيزة",
  "DefaultCertAttendanceTop": "يشهد المركز السعودي للتنافسية والأعمال بأن",
  "DefaultCertAttendanceMiddle": "{ذكر | أنثى } / {الاسم}",
  "DefaultCertAttendanceBottom": "قد حضرت البرنامج التدريبي '{اسم التدريب}'\n بإجمالي {الساعات} ساعة للفترة من {من التاريخ} حتى {حتى التاريخ}",
  "DefaultCertAttendanceBottom2": "متمنين لها دوام التوفيق",
  "DefaultCertAttendanceBottom3": "مدير عام إدارة الشراكات وتطوير القدرات",
  "Manager Name": "{اسم المدير}",
  "Partner Name": "شريك معتمد لشركة {اسم الشريك}",
  "DefaultCertMinistryText1": "نتيجة الاختبار الشامل",
  "DefaultCertMinistryText2": "ووفقاً لنتائج الاختبار الشامل، ورصد الأخطاء \n في الإجابات، نوصي بمراجعتكم لخدمات الجهات التالية:",
  "DefaultCertMinistryText3": "عدد الإجابات الخاطئة حسب الجهات",
  "DefaultCertMinistryText4": "كما تميزت إجابتكم في خدمات الجهات التالية:",
  "DefaultCertMinistryText5": "مع تمنياتنا لكم \n بالتوفيق والسداد",
  "Old password not correct": "كلمة المرور الحالية غير صحيحة",
  "You have been added as a trainer for a training": "تم إضافتك كمدرب لهذه الدورة التدريبية",
  "You have been added as a master trainer for a training": "تم إضافتك كمدرب أساسي لهذه الدورة التدريبية",
  "Create Type": "إنشاء نوع",
  "Add Managers": "إضافة مدراء",
  "Show Style": "طريقة العرض",
  "ou filter": "فرز",
  "Deleted data type": "المحذوفة",
  "All fields are required": "All fields are required",
  "Print Services": "إنشاء دليل الخدمات",
  "Admin Permission Panel": "إعدادات الصفحة الخارجية",
  "show": "عرض",
  "Signed": "المتاح",
  "all": "الجهات",
  "Fields to hide from template": "الحقول المراد إخفاؤها من القالب",
  "Data Fields": "حقول البيانات",
  "Signed Data": "المتاح",
  "Unsigned Data": "غير المتاح",
  "Both Data": "الكل",
  "Mail Send SuccessFully": "تم إرسال الرسالة بنجاح",
  "Print Selection": "طباعة أسئلة محددة",
  "Print Questions": "طباعة أسئلة عشوائية",
  "Sign History": "سجلات البيانات المعتمدة",
  "Undo delete": "استرداد",
  "Returned": " تم الاسترداد  ",
  "we sent a verification code to your email": "لقد تم ارسال الكود إلى بريدك الإلكتروني",
  "seconds remaining to send email again": "يمكنك طلب كود جديد خلال",
  "seconds": "ثانية",
  "not available for ministry page": "غير متاحة للمستثمرين - تمت من قبل:",
  "Please Write a reason for update": "السبب مطلوب",
  "Closed": "مغلق",
  "Average Rating": "متوسط التقييم",
  "View Rating Graph": "عرض الرسم البياني للتقييم",
  "Certificate Top Text is Required": "نص الشهادة العلوي مطلوب",
  "Certificate Middle Text is Required": "نص الشهادة الأوسط مطلوب",
  "Certificate Bottom 1 Text is Required": "نص الشهادة السفلي 1 مطلوب",
  "Certificate Bottom 2 Text is Required": "نص الشهادة السفلي 2 مطلوب",
  "Certificate Bottom 3 Text is Required": "نص الشهادة السفلي 3 مطلوب",
  "Manager Name is required": "اسم المدير مطلوب",
  "Image is not uploaded and no url found": "لم يتم تحميل الصورة ولم يتم العثور على عنوان URL",
  "Partner Name is required": "اسم الشريك مطلوب",
  "Training Results": "نتائج التدريبات",
  "number_of_users": "عدد المستخدمين",
  "number_of_trainers": "عدد المدربين",
  "completed_attendees": "التدريبات المكتملة",
  "Session Online": "جلسات أونلاين",
  "Session Onsite": "جلسات حضورية",
  "Session Survey": "استبيانات الجلسة",
  "Session Assessment": "اختبارات الجلسة",
  "Survey": "الاستبيانات",
  "avgUserRating": "متوسط تقييم المستخدم",
  "avgTrainerRating": "متوسط تقييم المدرب",
  "Unsign Data": "عدم الإتاحة للمستثمرين",
  "BY_QR": "عن طريق رمز الاستجابة السريعة QR",
  "BY_PC": "من قبل الإدراة",
  "Marked": "حاضر",
  "Training Programs": "البرامج التدريبية",
  "Publish Program": "نشر البرامج التدريبية",
  "Add Training Program": "إنشاء برنامج تدريبي",
  "Assign Ous": "تحديد الوحدة التنظيمية",
  "Program Form": "ملف البرنامج",
  "Select Trainings": "حدد الدورة التدريبية",
  "Confirmation": "التأكيد",
  "Training program title": "عنوان البرنامج التدريبي",
  "Training program title is required": "عنوان البرنامج التدريبي مطلوب",
  "Program description": "الوصف",
  "Are you sure you want to mark this attendance?": "هل أنت متأكد من أنك تريد تحديد الحضور لهذا المستخدم؟",
  "Training Program Title": "عنوان البرنامج التدريبي",
  "Training Program Title is required": "عنوان البرنامج التدريبي مطلوب",
  "ProgramDescription": "الوصف",
  "Trainings Details": "تفاصيل الدورة التدريبية",
  "Training Filter": "فلتر الدورات التدريبية",
  "Please Select training type": "حدد نوع الدورة التدريبية",
  "Unsupported Extension!": "صيغة الملف غير مدعومة",
  "Training Program": "البرامج التدريبية",
  "Select OU for the Training Program": "حدد الوحدة التنظيمية للبرنامج التدريبي",
  "Please Select Ou": "يرجى تحديد الوحدة التنظيمية",
  "Form Details invalid": "المعلومات غير مكتملة",
  "No course is selected in training Program": "لم يتم اختيار الدورة للبرنامج التدريبي",
  "Unlock Question & Edit": "إلغاء ارتباط السؤال والتعديل",
  "Please Select Conditional Question": "يرجى تحديد السؤال الشرطي",
  "Disabled PLease Unlock to Edit": "قم بإلغاء ارتباط السؤال ثم التعديل بالضغط على أيقونة القفل",
  "Enter Program Details": "تفاصيل البرنامج التدريبي",
  "Trainings": "الدورات التدريبية",
  "Users Completed training": "المستخدمين الذين أكملوا الدورة التدريبية",
  "Users that will added to the training": "المستخدمين الذين سيتم اضافتهم للدورة التدريبية",
  "Confirmation Details": "التأكيد",
  "Selected Trainings": "الدورات التدريبية المحددة",
  "Users added in training program": "المستخدمين المضافين في البرنامج التدريبي",
  "Assigned Ous": "الوحدات التنظيمية المحددة",
  "Users added in training": "المستخدمين المضافين في الدورة التدريبية",
  "Training Program Details": "تفاصيل البرامج التدريبية",
  "Training Filters": "فلتر الدورات التدريبية",
  "The course selected is in progress please select form below options to recreate course": "الدورة التدريبية التي تم اختيارها مستمرة، يرجى الاختيار من الآتي:",
  "Already Completed": "المكتملة",
  "Add Training to Training Program": "إضافة دورة تدريبية لبرنامج تدريبي",
  "Remove Training": "حذف الدورة التدريبية",
  "Invalid Form": "يرجى تعبئة جميع الخانات",
  "You are registered in another session of this training": "You are registered in another session of this training",
  "Add Question to QuestionBank": "إعدادت السؤال",
  "Merge Users": "دمج المستخدمين",
  "start and end date required": "تاريخ البدء والانتهاء مطلوب",
  "Add all incomplete users into a copy": "إضافة المستخدمين الذين لم يكملوا الدورة التدريبية إلى نسخة من هذه الدورة التدريبية.",
  "Add no existing others users into copy": "إضافة مستخدمين جدد إلى نسخة من هذه الدورة التدريبية",
  "Certificate Record": "السجل التدريبي",
  "Certificate Save": "تعديل",
  "Select service": "ربط بالخدمة",
  "Drag your choices here to rank them": "لإعادة الترتيب قم بسحب وإفلات الإجابة",
  "Sub Questions": "أسئلة الاختبار",
  "Total Sub Questions": "إجمالي أسئلة الاختبار",
  "Total Questions": "إجمالي الأسئلة",
  "No record found, newly created data.": "لم يتم العثور السجل، تم إنشاء بيانات جديدة.",
  "Please Select Users to Send Email": "الرجاء تحديد المستخدمين لإرسال رسالة على البريد الإلكتروني",
  "Please Enter Email Text": "الرجاء إدخال نص رسالة البريد الإلكتروني",
  "Please Enter Email Link": "الرجاء إدخال رابط البريد الإلكتروني",
  "Link is not Correct": "رابط غير صحيح",
  "Add User to Survey": "إضافة المستخدمين",
  "Email Text": "نص الرسالة",
  "Send Mail": "إرسال",
  "Show Option to View Certificate on Profile Page": "إظهار خيار عرض الشهادة على صفحة الملف الشخصي",
  "Show Option to View Results on Profile Page": "إظهار خيار عرض النتائج على صفحة الملف الشخصي",
  "new branch coach": "المدرب",
  "certificate title": "عنوان الشهادة",
  "Unidentified": "دون مستوى",
  "Default Score": "درجة السؤال الافتراضية",
  "Unregistered Users": "المستخدمين غير المسجلين",
  "Add Unregistered Users":"إضافة البريد الإلكتروني للمرشح غير المسجل",
  "Trainings in training Program": "الدورات التدريبية في البرنامج التدريبي",
  "User Management": "إدارة المستخدمين",
  "Add Enquiry": "إضافة استعلام",
  "Created By Info": "معلومات المنشئ",
  "Created By Name": "الاسم",
  "Created By Email": "البريد الإلكتروني للمنشئ",
  "Created Time": "تاريخ الإنشاء",
  "Add Sub Criteria": "إضافة المعايير الفرعية",
  "Impact Magerment Task": "اطلاع قياس الأثر للمدراء",
  "Impact Not Created": "لم يتم إنشاء قياس الأثر ",
  "Impact Created": "م إنشاء قياس الأثر",
  "Invite": "دعوة",
  "Attempt Survey": "بدء الاطلاع",
  "Impact Settings": "إعدادات قياس الأثر",
  "Send Invitation": "ارسال دعوة ",
  "time": "الوقت",
  "Select Attendees": "حدد المشاركين",
  "Date Has Passed": "انتهى الوقت ",
  "Rest Schedule": "إعادة جدولة",
  "Impact Measurement": "قياس الأثر",
  "Select Trainer": "حدد المدرب",
  "Select Manager": "حدد المدير",
  "For Manager": "للمدير",
  "for Trainer": "للمدرب",
  "Internal Branch": "اسم الإدارة",
  "Please Provide Valid Email": "يرجى كتابة بريد الإلكتروني صالح",
  "Please Provide Valid Phone": "يرجى إدخال رقم هاتف صالح",
  "Please Select Gender": "حدد الجنس",
  "Please Provide Valid AltEmail": "يرجى كتابة بريد إلكتروني بديل صالح",
  "Please Provide Valid AltPhone": "يرجى إدخال رقم هاتف بديل صالح",
  "No Question Added based on applied filters": "لا توجد اي أسئلة بناءً على الفلتر المطبق",
  "MS Add Responsible": "المعنيين بالمشروع",
  "Sink Users": "Sink Users",
  "Add a question Survey": "لوحة تحكم الاستبيان",
  "Add a question Assessment": "لوحة تحكم الاختبار",
  "Add a question Topic": "لوحة تحكم الموضوع",
  "Regenerate Results": "تحديث النتائج",
  "Select Question Topics": "حدد التصنيف",
  "Question Topics": "تصنيف الأسئلة",
  "Add new question topic": "إضافة تصنيف جديد",
  "enter question classification name": "أدخل اسم تصنيف السؤال",
  "No question classification created": "لم يتم إنشاء تصنيف للأسئلة",
  "External User Fields": "حقول المستخدم الخارجي",
  "Link Question": "ربط السؤال",
  "Please select at least 2 responsibles": "يرجى اختيار اثنين على الأقل",
  "Please Select External PM": "يرجى تحديد مدير المشروع الخارجي",
  "Please Enter Internal PM Email": "يرجى إدخال البريد الإلكتروني لمدير المشروع الداخلي",
  "Internal PM does not Exist with this Email": "لا يوجد مدير مشروع داخلي بهذا البريد الإلكتروني",
  "Company with the same name already exists": "توجد شركة بنفس الاسم",
  "Email & Alternative Email cannot be the same": "لا يمكن أن يكون البريد الإلكتروني لمدير المشروع والبريد الإلكتروني للشخص البديل متماثلين",
  "PmEmail already exists with a vendor": "البريد الإلكتروني لمدير المشروع مستخدم في الجهة المنفذة من قبل",
  "AltPmEmail already exists with a vendor": "البريد الإلكتروني للشخص البديل  مستخدم في الجهة المنفذة من قبل",
  "Please Select Topic of Following Questions": "يرجى اختيار مواضيع الأسئلة",
  "MS Description": "وصف المشروع",
  "Internal PM Email": "البريد الإلكتروني لمدير المشروع",
  "earliest": "أقدم النتائج",
  "latest": "أحدث النتائج",
  "lowest": "أقل درجات",
  "highest": "أعلى درجات",
  "Result Grades": "سلم الدرجات",
  "ClassificationQue": "التصنيف",
  "Attempt Time (mintues)": "المدة الزمنية لإتمام الاختبار (بالدقائق)",
  "Average Time Taken": "متوسط الوقت المستغرق",
  "Allow Redo": "السماح بإعادة التنفيذ",
  "Edit Results": "تعديل النتائج ",
  "revision": "تصحيح",
  "timeTaken": "الوقت المستغرق",
  "Total Time": "مدة الاختبار",
  "Lowest Time": "أقل وقت مستغرق",
  "Highest Time": "أطول وقت مستغرق",
  "Overall average for the assessment in percentage": "المعدل العام بالنسبة",
  "Overall average for the assessment in marks": "المعدل العام بالدرجة",
  "Overall average for the assessment in grades": "المعدل العام بالتقدير",
  "Send Certificate": "إرسال الشهادة",
  "Are you sure you want to send Certificate to All Users": "هل أنت متأكد من إرسال هذه الشهادة إلى جميع المستخدمين.",
  "Overall average heading": "المعدل العام",
  "Select Correct Answer": "حدد الإجابة الصحيحة",
  "Start data should be less than end date": "تاريخ البدء يجب أن يكون أقل من تاريخ الانتهاء",
  "They got the question wrong": "أخطأوا في السـؤال",
  "That is of all": "أي ما يعادل",
  "of all the test takers": "من جميع المختبرين",
  "the correct answer": "الخيار الصحيح",
  "Multiple users": "العديد من المستخدمين",
  "Results Genereted Successfully": "تم إعادة حساب النتائج بنجاح",
  "SETTINGS_AND_QUESTIONS": "نسخ الأسئلة والإعدادات",
  "ONLY_QUESTIONS": "نسخ الأسئلة فقط",
  "Copy Settings": "نسخ الإعدادات",
  "Assessment Results": "نتائج الاختبارات",
  "Correct answers according to topics": "الإجابات الصحيحة حسب المواضيع",
  "the list of users who have attempted multiple times": "قائمة المختبرين الذين قاموا بملء أكثر من نموذج واحد للاختبار",
  "number of times": "عدد المرات",
  "isNumeric": "أدخل أرقام",
  "Thank You Messages": "رسائل الشكر",
  "Dynamic Message": "رسالة شكر في حال تحقق الشروط",
  "Downlaod Cache Attempts": "أرشيف المحاولات",
  "Limit": "الحد الأقصى",
  "Total Participant": "إجمالي عدد المختبرين",
  "Total Marks out of": "الدرجة الكلية من",
  "Total Grades out of 100": "النسبة 100%",
  "Wrong Answer": "الإجابات الخاطئة",
  "Knowledge Library Content Management": "إدارة محتوى مكتبة المعرفة",
  "Add | Edit | Delete": "إضافة  |  تعديل  |  حذف",
  "correct incorrect stats": "تحميل إحصائيات الإجابات الصحيحة والخاطئة",
  "Ms": "المتسوق الخفي",
  "Favorite": "المفضلة",
  "Download Excel": "تنزيل ملف إكسل",
  "Download Excel With Questions": "تنزيل ملف إكسل مع الأسئلة",
  "Download Excel for user data only": "تنزيل ملف إكسل لبيانات المستخدمين فقط",
  "Download PDF": "تحميل PDF",
  "Download Certificate": "تنزيل الشهادة",
  "Download PowerPoint": "تنزيل ملف  PowerPoint",
  "submittedTime": "وقت الإرسال",
  "Announcements": "الإعلانات",
  "Target Users": "المستخدم المستهدف",
  "Update announcement": "تحديث الإعلان",
  "Create a new announcement": "إنشاء إعلان جديد",
  "New Announcements": "إعلان جديد",
  "For All": "جميع المستخدمين",
  "Announcement Results": "نتائج الإعلان",
  "Total Count": "العدد الإجمالي",
  "Seen Count": "إجمالي المشاهدة",
  "SeenAt": "تمت المشاهدة منذ",
  "Users List": "قائمة المستخدمين",
  "Update Data Ou": "تغيير التصنيف",
  "Captcha was not loaded due to internet connectivity. Please click the icon to reload.": "لم يتم تحميل رمز التحقق Captcha بسبب اتصال الإنترنت. يرجى النقر على الأيقونة لإعادة التحميل.",
  "Reload Captcha": "إعادة تحميل كلمة التحقق",
  "Periodic Reports": "التقارير الدورية",
  "Create Report": "إنشاء تقرير",
  "Periodic Report": "التقرير الدوري",
  "No knowledge portal updates during the selected period": "لم يتم إجراء أي تحديثات في بوابة المعرفة خلال الفترة المحددة أعلاه.",
  "No comments to display": "لا توجد تعليقات لعرضها",
  "Reports": "التقارير",
  "Next Date": "التاريخ التالي",
  "Report Form": "من تاريخ",
  "Report To": "إلى تاريخ",
  "Report From": "من تاريخ",
  "Close": "إغلاق",
  "SIGNED": "مكتمل",
  "Error fetching reports": "Error fetching reports",
  "Next Report Date": "التاريخ التالي",
  "After Number of days": "عدد الأيام",
  "Please select an entity": "يرجى تحديد الوحدة التنظيمية",
  "Please select a manager": "يرجى تحديد المدير",
  "Please select a number of days": "يرجى تحديد عدد الأيام",
  "Please select a time": "يرجى تحديد الوقت",
  "Please confirm the report": "يرجى مراجعة وتأكيد جميع بيانات الجهة على بوابة المعرفة",
  "Please agree to the terms and conditions": "يرجى الموافقة على الشروط والاحكام",
  "New Report form started": "تم إنشاء تقرير جديد",
  "Have all the organization data been reviewed on the knowledge portal?": "هل تم مراجعة جميع بيانات الجهة على بوابة المعرفة؟",
  "No": "لا",
  "Please add comments": "ملاحظات:",
  "I agree to the terms and conditions": "أقر بأن جميع المعلومات صحيحة وموثوقة ويمكن نشرها واعتمادها للرد على استفسارات المستثمرين.",
  "Please confirm": "تأكيد",
  "Report updated successfully": "تم تحديث التقرير بنجاح",
  "Failed to update report": "فشل تحديث التقرير",
  "Manager updated successfully": "تم تأكيد البيانات",
  "Failed to update manager": "فشل تحديث المدير",
  "No reports found": "لا يوجد تقارير",
  "Report deleted successfully": "تم حذف التقرير بنجاح",
  "Failed to delete report": "فشل حذف التقرير",
  "Not signed yet": "لم يتم التوقيع بعد",
  "theme settings": "إعدادات الثيمات",
  "theme note": "بعد اختيار الوحدة التنظيمية، يرجى تحديد لون الثيم.",
  "Theme Content Background Colors": "الألوان العامة للثيم",
  "Text Colors": "لون النص",
  "Navbar Colors": "لون شريط التنقل",
  "Button Hover Colors": "تدرج لوني لزر التمرير",
  "User Profile & Dark Blue Text": "الملف الشخصي للمستخدم",
  "test heading": "لون رأس الصفحة",
  "theme updated successfully": "تم تحديث الثيم بنجاح",
  "Permission Requests": "طلبات الصلاحيات",
  "Currently, there are no permissions available in the system. To proceed, please create a new permission by clicking the button below. This will allow you to define the access or actions required for your process.": "Currently, there are no permissions available in the system. To proceed, please create a new permission by clicking the button below. This will allow you to define the access or actions required for your process.",
  "Request Permission": "Request Permission",
  "Contact Officer (Applicant Details)": "جهة الاتصال (بيانات مقدم الطلب)",
  "Add Sample Question": "أضف سؤالًا نموذجيًا لملف PDF",
  "Copy": "نسخ",
  "See Results": "عرض النتائج",
  "Material_Text": "المصادر النصية",
  "Video": "فيديو",
  "Not Marked": "غير محدد",
  "s selected": "تم تحديد",
  "View Session": "التفاصيل",
  "Subtotal": "المبلغ الإجمالي",
  "Assign Attendees": "الحضور",
  "Difficult": "صعب",
  "General information about the test": "البيانات العامة للاختبار",
  "know": "معرفة",
  "train": "تدريب",
  "develop": "تطوير",
  "Expert": "اختر خبير",
  "Add New": "إضافة جديد",
  "Request Permissions": "طلب الصلاحيات",
  "What permissions are required": "ماالصلاحيات المطلوبة؟",
  "System Administration": "إدارة النظام",
  "Training Management": "إدارة التدريب",
  "Content Management": "إدارة المحتوى",
  "General Data": "البيانات العامة",
  "Request For": "نوع الطلب",
  "Agency": "الوكالــــة أو الإدارة",
  "Contact officer name": "اسم الموظف",
  "question maker name": "اسم الموظف",
  "Question Maker Details": "بيانات معد الأسئلة",
  "Question Maker": " معدالأسئلة",
  "Order Data": "بيانات الطلب",
  "Test Goal": "هــــــدف الاختبار",
  "Measuring overall employee performance": "قياس الأداء العام للموظفين",
  "Performance measurement for membership New employee": "قياس أداء لمنح عضوية موظف جديد",
  "Renewal of practicing employee": "قياس أداء لتجديد عضوية موظف ممارس",
  "Other": "أخرى",
  "Please specify...": "يرجى التحديد...",
  "Question Data": "بـنـــــــــــاء الأسئلة",
  "Question Level": "مستوى السؤال",
  "All of them": "الكل",
  "Attendees Details": "بيانات الحضور",
  "Number of Employees": "عدد الموظفين",
  "50 employees or less": "50 موظف أو أقل - نموذج اختبار واحد",
  "50 to 150 employees": "50 - 150 موظف - 2 نموذج اختبار",
  "More than 150 employees": "أكثر من 150 موظف - 3 نماذج اختبار",
  "Test Management": "حـــــصــــــــــــــر المختبريـــــن وتحديـــــــــــد الملاحظين",
  "Number of Regions": "عدد المناطق",
  "10 branches": "10 فرع",
  "20 branches": "20 فرع",
  "30 branches": "30 فرع",
  "Number of Regions (Other) is required": "عدد المناطق (أخرى) مطلوب",
  "Please enter a valid format": "يرجى إدخال تنسيق صحيح",
  "must be at least": "يجب أن يكون على الأقل",
  "must be at most": "يجب أن يكون على الأكثر",
  "must be at least 3 characters": "يجب أن يكون على الأقل 3 أحرف",
  "must be at least 1 characters": "يجب أن يكون على الأقل حرف واحد",
  "Test date cannot be in the past": "تاريخ الاختبار لا يمكن أن يكون في الماضي",
  "range must be sequential with other ranges": "يجب أن يكون النطاق متسلسلاً مع النطاقات الأخرى",
  "is invalid": "غير صالح",
  "This section is required": "هذا القسم مطلوب",
  "Minimum length is": "الحد الأدنى للطول هو",
  "characters": "أحرف",
  "Invalid value": "قيمة غير صالحة",
  "Agency or Management": "الوكالة أو الإدارة",
  "Request Type": "نوع الطلب",
  "Mobile Number": "رقم الهاتف المحمول",
  "Employee Name": "اسم الموظف",
  "Test Goal (Other)": "هدف الاختبار (أخرى)",
  "Number of Questions per Model": "عدد الأسئلة لكل نموذج",
  "Number of Regions (Other)": "عدد المناطق (أخرى)",
  "Examination Halls": "قاعات الامتحان",
  "Examination Halls (Other)": "قاعات الامتحان (أخرى)",
  "Test Sessions": "جلسات الاختبار",
  "At least one test session is required": "مطلوب على الأقل جلسة اختبار واحدة",
  "Are you sure you want to remove this test session?": "هل أنت متأكد من أنك تريد إزالة جلسة الاختبار هذه؟",
  "Agency or Management is required": "الوكالة أو الإدارة مطلوبة",
  "Request Type is required": "نوع الطلب مطلوب",
  "Employee Name is required": "اسم الموظف مطلوب",
  "Mobile Number is required": "رقم الهاتف المحمول مطلوب",
  "Please specify number of halls...": "يرجى تحديد عدد القاعات...",
  "Please specify number of regions...": "يرجى تحديد عدد المناطق...",
  "New Permission Request Created": "تم إنشاء طلب صلاحية جديد",
  "Examination Hall": "عدد قاعات الاختبار",
  "10 halls": "10 قاعات",
  "30 halls": "30 قاعة",
  "50 halls": "50 قاعة",
  "Suggest grading scale": "مقترح سلم الدرجات (من 100)",
  "Not Passed": "غير مجتاز",
  "Good": "جيد",
  "veryGood": "جيد جدًا",
  "excellent": "ممتاز",
  "Observers Note": "إجمالي عدد الملاحظين (يجب أن يتطابق مع عدد القاعات بحيث يتم تحديد ملاحظ واحد لكل قاعة اختبار)",
  "Enter any additional notes about observers...": "ملاحظ",
  "Test Schedule": "أوقات",
  "Test Name": "الاسم",
  "Test Date": "تاريخ",
  "Start Time": "وقت بدء",
  "Enter test name": "اكتب الاسم هنا",
  "Test Report": "تقرير",
  "(Detailed) Delivered within 15 days of the test": "(مفصل) يسلم بعد 15 يوم من عقد لاختبا",
  "Given one year after the test is conducted by two days": "(عام) يسلم بعد يومين من عقد الاختبار",
  "Select Status": "حدد الحالة",
  "Select Date Range": "حدد نطاق التاريخ",
  "Clear": " إعادة تعيين ",
  "Survey form": "النماذج",
  "SURVEY": "الاستبيانات",
  "ASSESSMENT": "الاختبار",
  "TRAINING": "التدريب",
  "View/Edit Questions": "عرض/تعديل الأسئلة",
  "View Results": "عرض النتائج",
  "More Actions": "المزيد من الإجراءات",
  "Update Permission Request": "تحديث طلب الصلاحية",
  "Contact Officer Name": "اسم ضابط الاتصال",
  "Contact Officer Email": "البريد الإلكتروني لضابط الاتصال",
  "Question Maker Name": "اسم معد الأسئلة",
  "Question Maker Email": "البريد الإلكتروني لمعد الأسئلة",
  "Error updating permission": "خطأ في تحديث الصلاحية",
  "Update Survey": "تحديث الاستبيان",
  "Error fetching assessment": "خطأ في جلب بيانات الاختبار",
  "Error fetching survey": "خطأ في جلب بيانات الاستبيان",
  "Error updating assessment": "خطأ في تحديث الاختبار",
  "Error updating survey": "خطأ في تحديث الاستبيان",
  "Permission Approved Successfully": "تم الموافقة على الصلاحية بنجاح",
  "Are you sure you want to approve this permission request?": "هل أنت متأكد من الموافقة على طلب الصلاحية هذا؟",
  "Approve Confirmation": "تأكيد الموافقة",
  "Reject Confirmation": "تأكيد الرفض",
  "Leave a comment here": "اترك تعليقاً هنا",
  "Permission request has been updated successfully": "تم تحديث طلب الصلاحية بنجاح",
  "Permission request has been submitted successfully": "تم إرسال طلب الصلاحية بنجاح",
  "Are u sure to approve permission": "أوافق على منح المستخدم صلاحية الوصول إلى الميزات المطلوبة.",
  "Select a ou": "حدد الجهات",
  "Reports created successfully": "تم إنشاء التقارير بنجاح",
  "You are not authorized to update reports from this organizational unit": "ليست لديك الصلاحية لتحديث التقارير من هذه الوحدة التنظيمية",
  "Select manager": "اختر الخبير",
  "PDF Maker": "إنشاء حقائب تدريبية",
  "Drawing Mode": "وضع الرسم",
  "Print Document": "طباعة المستند",
  "Enable Editing": "تحرير",
  "Elements": "العناصر",
  "Subcategories": "الأقسام الفرعية",
  "Subheading": "العنوان الفرعي",
  "Paragraph": "الفقرة",
  "Caption": "العنوان التوضيحي",
  "Shapes": "الأشكال",
  "Layers": "طبقات",
  "Page": "الصفحة",
  "Duplicate Page": "تكرار الصفحة",
  "Opacity": "الشفافية",
  "Flip horizontally": "قلب أفقيًا",
  "Flip vertically": "قلب عموديًا",
  "Cover Page": "صفحة الغلاف الأول",
  "Intellectual Property": "الملكية الفكرية",
  "intellectual-property-bg": "الملكية الفكرية",
  "Introduction": "المقدمة",
  "Image Banner": "صفحة الشعار",
  "Welcome Page": "صفحة الشكر والترحيب",
  "Footer Page": "صفحة الغلاف الأخير",
  "Training Notes Page": "صفحة التقويم القبلي",
  "Notes Page": "صفحة الملاحظات",
  "Reference and Resource": "صفحة المراجع",
  "License Table Page": "جدول الترخيص",
  "Model Answer/Boxed Page": "صفحة الاجابة النموذجية والصفحة المؤطرة",
  "Index Page 1": "الفهرس",
  "Activity/Profile Page": "صفحة النشاط والملف الشخصي",
  "Services Classification/Diagram Page": "صفحة تصنيف الخدمات والرسم البياني",
  "Model Answer/Boxed Page 2": "صفحة الاجابة النموذجية والصفحة المؤطرة 2",
  "Model Answer/Boxed Page 3": "صفحة الاجابة النموذجية والصفحة المؤطرة 3",
  "Session Summary (Circle Boxes) Page": "صفحة ملخص الجلسة (مخطط دائري)",
  "Activity/Profile Page 3": "صفحة النشاط والملف الشخصي 3",
  "Activity/Profile Page 4": "صفحة النشاط والملف الشخصي 4",
  "Numeric Steps/Model Answer Page": "صفحة الخطوات المرقمة والإجابة النموذجية",
  "Ministry Communication/Model Answer Page": "صفحة التواصل مع الجهات",
  "Session Summary (Rectangle Diagram) Page": "صفحة ملخص الجلسة (مخطط مستطيل)",
  "Ministry Authorities Page": "صفحة الوزارات والهيئات",
  "KWL Self-Knowledge Table Page": "جدول المعرفة الذاتية",
  "KWL Self-Knowledge Table 2 Page": "جدول المعرفة الذاتية 2",
  "KWL Self-Assessment Page": "الجدول المعرفي الذاتي KWL.",
  "Activity/Profile Page 5": "صفحة النشاط والملف الشخصي 5",
  "Session Table Page": "جدول الجلسة",
  "Notes Dotted Page": "صفحة ملاحظات منقطة",
  "Simple Banner Logo Page": "صفحة شريط وشعار بسيط",
  "Banner Logo Sticky Bar Page": "صفحة شريط وشعار بسيط بالصلاية",
  "Grey Box Table Page": "صفحة الجدول بالصندوق الرمادي",
  "Trainer Instructions Checklist Page": "تعليمات المدرب وقائمة التحقق",
  "Pending in orders": "طلب جديد",
  "Thank You Welcome Diagram Page": "صفحة المقدمة",
  "Page 02": "صفحة دليل البرنامج٢",
  "Page 01": "صفحة دليل البرنامج1",
  "Page 03": "صفحة الخريطة الذهنية ١",
  "Page 04": "صفحة الخريطة الذهنية ٢",
  "Page 12": "صفحة اليوم التدريبي الأول",
  "Page 07": "صفحة مخطط الجلسة",
  "Page 15": " صفحة الوحدة ١",
  "Page 08": " صفحة الجلسة",
  "Page 05": "التقييم القبلي/ البعدي",
  "Page 06": "صفحة الملاحظات",
  "Banner Logo Gradient Page": " صفحة الوحدة / صفحة الختام",
  "Table Page 11": "صفحة خطة اليوم التدريبي",
  "Table Page 12": "التقييم الذاتي",
  "Trainer Instructions Long Page 1": "صفحة تعليمات المدرب المفصلة 1",
  "Trainer Instructions Simple Page": "إرشادات المدرب",
  "Trainer Instructions Simple Page 1": " إرشادات المدرب",
  "Assets": "الأيقونات",
  "Mind Map": "إضافة خريطة ذهنية",
  "Upload Asset": "إضافة أيقونات",
  "Model Answer/Boxed Page 4": "ورقة عمل ٢",
  "Session Summary (Circle diagram) Page": "صفحة ملخص الجلسة (مخطط دائري)",
  "Activity/Profile Page 2": "صفحة النشاط والملف الشخصي 2",
  "of": "من",
  "Fill": "الملء",
  "Border": "الحدود",
  "Width": "العرض",
  "Align Left": "محاذاة إلى اليسار",
  "Align Right": "محاذاة إلى اليمين",
  "Align Center": "محاذاة إلى الوسط",
  "Underline": "تحته خط",
  "Italic": "مائل",
  "Bold": "عريض",
  "Background": "الخلفية",
  "Color Presets": "إعدادات الألوان",
  "Custom Color": "لون مخصص",
  "Apply": "موافق",
  "Templates": "القوالب",
  "Quick Add": "إضافة سريعة",
  "Add Index Page": "أضف صفحة الفهرس",
  "Straight Line": "خط مستقيم",
  "Arrow": "سهم",
  "Arrow Right": "سهم يمين",
  "Arrow Left": "سهم يسار",
  "Outline": "إطار خارجي",
  "Circle": "دائرة",
  "Rectangle": "المستطيل",
  "Triangle": "مثلث",
  "Star": "نجمة",
  "Add Text": "إضافة نص",
  "Square": "مربع",
  "Heart": "قلب",
  "Polygon": "مضلع",
  "PDF Pages": "صفحات PDF",
  "Browse trainings": "نظام التدريب",
  "Quick search": "بحث",
  "Organization": "الجهات",
  "Ministry/Entity": "الوزارة/الجهة",
  "Department/Division": "الإدارة/القسم",
  "Select Ministry/Entity": "اختر الوزارة/الجهة",
  "Select Department/Division": "اختر الإدارة/القسم",
  "No departments available": "لا توجد إدارات متاحة",
  "Training category": "نوع التدريب",
  "Show More": "عرض المزيد",
  "Course:": "الدورة",
  "Basic information": "المعلومات الأساسية",
  "optional": "اختياري",
  "Skip": "تخطي",
  "Date Range": "المدة الزمنية",
  "Clear Filter": "إلغاء الفلتر",
  "Create Path": "إنشاء مسار",
  "Select Training Type": "نوع التدريب",
  "Please select the type of training you want to create": "يرجى تحديد نوع التدريب الذي ترغب في إنشائه",
  "Path": "مسار",
  "Program": "برنامج",
  "Course": "دورة",
  "Programs": "البرامج التدريبية",
  "Paths": "المسارات",
  "Sort by Date": "ترتيب حسب التاريخ",
  "Newest First": "الأحدث أولاً",
  "Oldest First": "الأقدم أولاً",
  "Publish Training": "يبنشر التدريب",
  "Create Program for Path": "إنشاء برنامج للمسار",
  "Showing": "عرض",
  "to": "إلى",
  "entries": "سجلات",
  "Clear Filters": "إعادة تعيين",
  "Show Less": "عرض أقل",
  "results of": "من",
  "Program Description": "وصف البرنامج",
  "type view": "نوع",
  "Create Training All": "إنشاء تدريب",
  "Select date range": "حدد المدة الزمنية",
  "Add to Program": "أضف إلى البرنامج التدريب",
  "Enter program title": "ادخل عنوان البرنامج التدريبي",
  "Enter program description": "أدخل وصف البرنامج التدريبي",
  "Add Program": "إضافة برنامج تدريبي",
  "Add Program to Path": "إضافة برنامج تدريبي إلى المسار",
  "Add Course to program": "إضافة دورة تدريبية إلى البرنامج التدريبي",
  "Add Courses from Existing": "إضافة دورات تدريبية من الدورات التدريبية الموجودة",
  "Add Programs from Existing": "إضافة برامج تدريبية من البرامج التدريبية الموجودة",
  "Select a Course to add to path:": "اختر للإضافة دورة تدريبية",
  "Select a program to add": "اختر للإضافة برنامج تدريبي",
  "Select a course to add": "اختر للإضافة دورة تدريبية",
  "Do you want to create new or add from existing?": "هل تريد إنشاء جديد أم الإضافة من الموجود؟",
  "Select a Program to add to path:": "اختر للإضافة برنامج تدريبي",
  "Select a Course to add to program:": "اختر للإضافة دورة تدريبية",
  "Program User Management": "إدارة مستخدمي البرنامج التدريبي",
  "Course User Management": "إدارة مستخدمي الدورة التدريبية",
  "Path User Management": "إدارة مستخدمي المسار",
  "Add User to Program": "إضافة مستخدم إلى البرنامج التدريبي",
  "OU": "الجهات",
  "Add to program": "أضف إلى البرنامج التدريبي",
  "Add Selected": "إضافة المحدد",
  "Deselect All": "إلغاء تحديد الكل",
  "Add User to Path": "إضافة مستخدم إلى المسار",
  "Publish Settings": "إعدادات النشر",
  "Number of attendees": "عدد الحضور",
  "Attendess that will be added":"قائمة المتدربين",
  "Publish to": "النشر إلى",
  "attendees": "الحضور",
  "Attendees": "عدد المشاركين",
  "Choose how you want to publish this training:": "اختر كيف تريد نشر هذا التدريب:",
  "Quick Publish": "نشر سريع",
  "Publish with default settings immediately": "النشر بالإعدادات الافتراضية مباشرة",
  "Publish Now": "نشر الآن",
  "Configure & Publish": "ضبط الإعدادات والنشر",
  "Go to User Management to configure settings first": "اذهب إلى إدارة المستخدمين لضبط الإعدادات أولاً",
  "Configure Settings": "ضبط الإعدادات",
  "Active Users Only": "المستخدمون النشطون فقط",
  "OU Attendees": "حضور الجهات",
  "Department": "القسم",
  "Add from Existing": "الإضافة من الموجودة",
  "Create New": "إنشاء جديد",
  "Pdf Type Management": "إدارة أنواع الحقائب التدريبية",
  "REVIEW": "قيد الاعتماد",
  "All PDFs": "جميع حقائب التدريبية",
  "No PDF types found.": " لم يتم العثور على أنواع حقائب التدريبية",
  "approved": "مُعتمد",
  "rejected": "غير معتمد",
  "No description": "لا يوجد وصف",
  "Table Pages": "صفحات الجداول",
  "Main Table": " صفحة الجدول الزمني",
  "Table 3 First": " صفحة الأدوات والوسائل",
  "Objectives Pages": "صفحات الأهداف",
  "Activity Pages": "صفحات الأنشطة",
  "Answer Pages": "صفحات الإجابات",
  "Summary Pages": "صفحات الملخص",
  "Divider Pages": "صفحات الفواصل",
  "No PDFs found. Create your first PDF!": " لم يتم العثور على حقائب تدريبية. قم بإنشاء أول حقيبة تدريبية!",
  "Introduction Pages": "صفحات المقدمة",
  "Mark Review": "إرسال للمراجعة",
  "Save training bag": "حفظ الحقيبة التدريبية",
  "PDF Information": "معلومات عن الحقيبة التدريبية",
  "Enter PDF title...": "اكتب اسم الحقيبة التدريبية",
  "Enter PDF description (optional)...": "اكتب الوصف (اختياري)",
  "PDF Type": "نوع الحقيبة التدريبية",
  "Select PDF Type": "حدد نوع الحقيبة التدريبية",
  "Save File": "حفظ",
  "PDF Updated At": "تم التحديث في",
  "Table Page 1": "صفحة الجدول الزمني",
  "Table Page 2": "صفحة الأدوات والوسائل",
  "Table Page 3": "الجدول الثالث",
  "Saved successfully": "تم الحفظ بنجاح",
  "Failed to save PDF data due to an unexpected error": "فشل في حفظ بيانات الحقيبة التدريبية بسبب خطأ غير متوقع",
  "Page approved": "الصفحة مقبولة",
  "Page rejected": "الصفحة مرفوضة",
  "PDF approved": "الحقيبة التدريبية مقبولة",
  "PDF rejected": "الحقيبة التدريبية مرفوضة",
  "Page accepted": "الصفحة مقبولة",
  "Training bag accepted": "الحقيبة التدريبية مقبولة",
  "Training bag rejected": "الحقيبة التدريبية مرفوضة",
  "Training bag marked for review": "تم تحديد الحقيبة التدريبية للمراجعة",
  "Failed to save": " فشل في الحفظ",
  "PDF Review": "الاعتماد",
  "Overall PDF Review": "اعتماد الحقيبة التدريبية",
  "Overall Comment": "التعليق",
  "Add an overall comment for the PDF...": "أضف تعليقًا للحقيبة التدريبية",
  "Approve PDF": "معتمد",
  "Reject PDF": "غير معتمد",
  "Are you sure you want to delete this PDF?": "هل أنت متأكد من رغبتك في حذف هذه الحقيبة التدريبية؟",
  "Are you sure you want to duplicate this PDF as a draft?": "هل أنت متأكد من رغبتك في تكرار هذه الحقيبة التدريبية كمسودة؟",
  "Save Comment": "حفظ التعليق",
  "Overall Review":"اعتماد الحقيبة التدريبية",
  "Page Review": "مراجعة الصفحة",
  "Add a comment for this page...": "يرجى كتابة تعليق لهذه الصفحة",
  "Updated": "تم التحديث",
  "No comments": "لا توجد تعليقات",
  "Delete Column": "حذف عمود",
  "Delete Row": "حذف صف",
  "Add Column": "إضافة عمود",
  "Add Row": "إضافة صف",
  "Reset Column Widths": "إعادة تعيين عرض الأعمدة",
  "Merge Cells": "دمج الخلايا",
  "Add Break": "إضافة استراحة",
  "Training Requests": "طلبات التدريب",
  "Pending approval": "بانتظار الموافقة",
  "Request rejected successfully": "تم رفض الطلب بنجاح",
  "No users found for your organizational units": "لا يوجد مستخدمون ضمن جهاتك",
  "Not enrolled": "غير مسجل",
  "Added": "مضاف",
  "Path Groups": " مجموعة المسارات",
  "Manage Path Groups": " إدارة  مجموعة المسارات",
  "Select a group": " اختر مجموعة",
  "Create Group": "إنشاء مجموعة",
  "Group Name": "اسم المجموعة",
  "Enter group name": "أدخل اسم المجموعة",
  "Select Paths": "اختر المسارات",
  "Search paths...": "ابحث في المسارات",
  "Update Group": "تحديث المجموعة",
  "Edit Path Group": "تعديل المجموعة",
  "Confirm Delete": "تأكيد الحذف",
  "Are you sure you want to delete this path group?": "هل أنت متأكد أنك تريد حذف هذه المجموعة؟",
  "Path group created successfully": "تم إنشاء المجموعة بنجاح",
  "Path group deleted successfully": "تم حذف مجموعة المسارات بنجاح",
  "Failed to delete path group": "فشل في حذف مجموعة المسارات",
  "Error deleting path group:": "حدث خطأ أثناء حذف مجموعة المسارات",
  "Failed to update path group": "فشل في تحديث مجموعة المسارات",
  "Path group updated successfully": " تم تحديث مجموعة المسارات بنجاح",
  "Error updating path group": "حدث خطأ أثناء تحديث مجموعة المسارات",
  "Group name is required": "اسم المجموعة مطلوب",
  "Error creating path group:": "حدث خطأ أثناء إنشاء مجموعة المسارات",
  "Failed to load path groups": "فشل في تحميل مجموعة المسارات",
  "Error loading path groups:": "حدث خطأ أثناء تحميل مجموعة المسارات",
  "Required": "مطلوب",
  "Loading...": "جاري التحميل...",
  "Add program": "إضافة برنامج تدريبي",
  "Add course": "إضافة دورة تدريبية",
  "View Timeline": "عرض الجدول الزمني",
  "Search groups...": "ابحث في المجموعات",
  "Create Path Group": "إنشاء مجموعة المسارات",
  "Add User to Course": "إضافة مستخدم إلى الدورة التدريبية",
  "No attendees found in selected OUs": "لم يتم العثور على حضور في الجهات المحددة",
  "Path Required": "المسار إلزامي",
  "Program Required": "البرنامج إلزامي",
  "Automatically selected from training request": "تم اختيارها تلقائياً من طلب التدريب",
  "Synchronous": "متزامن",
  "Asynchronous": "غير متزامن",
  "Timeline Type": "نوع الدورة التدريبية",
  "Timeline Type required": "نوع الدورة التدريبية مطلوب",
  "Create New Course": "إضافة دورة تدريبية",
  "Add Users from OU": "إضافة مستخدمين من الجهة",
  "Select Organizational Unit": "حدد الجهة",
  "Select OU to fetch users": "حدد الجهة للحصول على المستخدمين",
  "Attendees Requests": "طلبات المستخدمين",
  "No pending requests": "لا توجد طلبات معلقة",
  "Current Attendees": "المشاركون الحاليون",
  "Pending Requests": "طلبات قيد الانتظار",
  "Publisher Approval Pending": "بانتظار موافقة الناشر",
  "Pending Publisher Approval": "بانتظار موافقة الناشر",
  "Awaiting Publisher Approval": "بانتظار موافقة الناشر",
  "No pending publisher approvals": "لا توجد طلبات بانتظار موافقة الناشر",
  "Require Publisher Approval": "يتطلب موافقة الناشر",
  "When enabled, all registered users will need publisher approval before being added to the training": "عند تفعيل هذا الخيار، سيحتاج المستخدمون إلى موافقة الناشر قبل إضافتهم إلى التدريب",
  "Attendee approved and added successfully": "تمت الموافقة على المستخدم وإضافته بنجاح",
  "Attendee rejected successfully": "تم رفض المستخدم بنجاح",
  "Failed to approve attendee": "فشل في الموافقة على المستخدم",
  "Failed to reject attendee": "فشل في رفض المستخدم",
  "Your request has been submitted for publisher approval": "تم إرسال طلبك للموافقة من قبل الناشر",
  "Request submitted for publisher approval": "تم إرسال الطلب للموافقة من قبل الناشر",
  "Total Attendees in course": "الإجمالي",
  "OUs": "الجهة",
  "Selected": "المحدد",
  "Select from following": "اختر من التالي",
  "Selected Branch": "الفرع المحدد",
  "Attendee added successfully": "تم إضافة المستخدم ",
  "You can reach to": "يمكنك الوصول إلى",
  "Content Manager": "الخبير",
  "Report Updated Automatically": "تم الاعتماد تلقائيًا ",
  "DRAFT": "مسودة",
  "Background Images": "صورة الخلفية",
  "Add Image": "إضافة صورة",
  "Fit": "الحجم",
  "No image selected": "لا يوجد صورة محددة",
  "Failed to add image": "فشل في إضافة الصورة",
  "Error adding image:": "حدث خطأ أثناء إضافة الصورة",
  "Image added successfully": "تم إضافة الصورة بنجاح",
  "Cover": "تغطية",
  "Contain": "احتواء",
  "Fill image": "ملء",
  "Repeat Image": "تكرار",
  "Center": "في الوسط",
  "Top": "في الأعلى",
  "Bottom": "في الأسفل",
  "Left": "إلى اليسار",
  "Right": "إلى اليمين",
  "Position": "الموضع",
  "Apply Image": "تطبيق التغييرات ",
  "Update Image": "تحديث الصورة",
  "Remove Image": "إزالة الصورة",
  "Current page has a background image": "الصفحة تحتوي على صورة خلفية",
  "Remove Break": "حذف الفواصل",
  "Table Controls": "خيارات الجدول",
  "No request ID found for saving draft": "لم يتم العثور على ID الطلب لحفظ المسودة",
  "Are you sure you want to delete this training path?": "هل أنت متأكد من رغبتك في حذف هذا المسار؟",
  "Material file uploaded successfully!": "تم رفع ملف المصادر بنجاح!",
  "Failed to upload material file": "فشل في رفع ملف المصادر",
  "Evidence file uploaded successfully!": "تم رفع ملف التوثيق بنجاح!",
  "Evidence image uploaded successfully!": "تم رفع صورة التوثيق بنجاح!",
  "Evidence Image": "صورة التوثيق",
  "Failed to upload evidence image": "فشل في رفع صورة التوثيق",
  "Failed to upload evidence file": "فشل في رفع ملف التوثيق",
  "Course image removed": "تمت إزالة صورة الدورة",
  "Failed to load image preview": "فشل في تحميل عرض الصورة",
  "Basic Information": "المعلومات اﻷساسية",
  "Session Details": "تفاصيل الجلسات",
  "Session Name 2": "اسم الجلسة",
  "Enter session name": "أدخل اسم الجلسة",
  "Session Materials": "مستندات أو مواد الورشة",
  "Material Name": "اسم المستند أو المادة",
  "Enter material name": "أدخل اسم المستند أو المادة",
  "Material name is required": "اسم المستند أو المادة مطلوب",
  "Evidence": "صورة الورشة",
  "No materials added yet. Click Add Material to get started.": "لم يتم إضافة مصادر بعد. اضغط 'إضافة مصادر' للبدء.",
  "No evidence added yet. Click Add Evidence to get started.": "لم يتم إضافة التوثيق بعد. اضغط 'إضافة التوثيق' للبدء.",
  "Add Evidence": "إضافة التوثيق",
  "Evidence Name": "اسم التوثيق",
  "Enter evidence name": "أدخل اسم التوثيق",
  "Upload Evidence File": "رفع ملف التوثيق",
  "Upload Material File": "رفع ملف المصادر",
  "Location Information": "معلومات المقر",
  "Attendees Management": "إدارة الحضور",
  "Phone": "رقم الهاتف",
  "Trainer Information": "معلومات المدرب",
  "Trainer Name": "اسم المدرب",
  "Enter trainer name": "أدخل اسم المدرب",
  "Trainer Email": "البريد الإلكتروني للمدرب",
  "Enter trainer email": "أدخل البريد الإلكتروني للمدرب",
  "Trainer Dropdown": "المدرب",
  "Enter Title": "أدخل العنوان",
  "Enter description": "أدخل الوصف",
  "Training Request": "طلب التدريب",
  "Training request completed successfully!": "تم إنشاء طلب التدريب بنجاح!",
  "Are you sure you want to register in this course?": "هل أنت متأكد من رغبتك في التسجيل في هذه الدورة؟",
  "traing user management": "الحضور",
  "Delete Confirmation": "تأكيد الحذف",
  "Are you sure you want to delete this training?": "هل أنت متأكد من رغبتك في حذف هذا التدريب؟",
  "Total Courses": "إجمالي عدد الدورات",
  "Completed": "مكتملة",
  "In Progress": "قيد التنفيذ",
  "Requested": "المطلوبة",
  "Training Overview": "نظرة عامة على التدريب",
  "Track your training progress and manage your courses": "تتبع تقدمك في التدريب وإدارة الدورات التدريبية",
  "Delete Path": "حذف مسار",
  "Training Path created": "تم إنشاء المسار بنجاح",
  "Training Path updated": "تم تحديث المسار بنجاح",
  "My Training Dashboard": "لوحة التدريب",
  "city required": "المدينة مطلوبة",
  "Ministry": "الجهة",
  "Trainer name is required": "اسم المدرب مطلوب",
  "Select the ministry": "اختر الجهة",
  "Refresh Users": "إرجاع المستخدمين",
  "Attendees refreshed successfully!": "تم إرجاع المستخدمين بنجاح",
  "Failed to load cities": "فشل في تحميل المدن",
  "Please select a date within the training period": "يرجى اختيار التاريخ ضمن فترة التدريب",
  "Please select a date within the current week": "يرجى تحديد تاريخ من هذا الأسبوع",
  "Session name is required": "اسم الجلسة مطلوب",
  "Training created successfully": "تم إنشاء التدريب بنجاح",
  "Direct Manager Dashboard": "لوحة معلومات المدير المباشر",
  "Senior Manager Dashboard": "لوحة معلومات المدير العام",
  "Employee Profile Dashboard": "لوحة معلومات ملف الموظف",
  "Content Management Dashboard": "لوحة معلومات خبير المحتوى",
  "Knowledge Portal System": "لوحة معلومات إحصاءات النظام",
  "Comments Dashboard": "لوحة معلومات التعليقات",
  "Question Bank Dashboard": "لوحة معلومات بنك الأسئلة",
  "Survey system": "لوحة معلومات الاستطلاع",
  "Testing system": "لوحة معلومات الاختبار",
  "Training System Dashboard": "لوحة معلومات نظام التدريب",
  "Mystery Shopper System": "لوحة معلومات المتسوق الخفي",
  "Knowledge Library System": "لوحة معلومات مكتبة المعرفة",
  "experts in the portal": "خبير المحتوى في بوابة المعرفة",
  "Logs": "سجلات مكتبة المعرفة",
  "User Login": "إحصائيات تسجيل دخول المستخدم",
  "User activity": "إحصائيات نشاط المستخدم",
  "Login per day": "تسجيل الدخول لكل يوم",
  "Login per Week": "تسجيل الدخول لكل أسبوع",
  "Login per Month": "تسجيل الدخول لكل شهر",
  "Activity per day": "النشاط لكل يوم",
  "Activity per Week": "النشاط لكل أسبوع",
  "Activity per Month": "النشاط لكل شهر",
  "Roles by Ministries": "أدوار المستخدمين حسب الوزارات",
  "MS Projects": "تفاصيل المشروع",
  "Stats": "إحصائيات",
  "Active surveys": "الاستطلاعات النشطة",
  "Pending surveys": "الاستطلاعات قيد الانتظار",
  "Closed surveys": "الاستطلاعات المغلقة",
  "Attempts": "محاولات الاستطلاع",
  "Testing": "الاختبارات",
  "Upload Evidence Image": "رفع الملف",
  "Available Trainers": "المدربين المتاحين",
  "Refresh Trainers": "إعادة تحميل المدربين",
  "Save Draft": "حفظ مسودة",
  "Save as draft": "حفظ كمسودة",
  "Save and publish": "حفظ ونشر",
  "Draft saved successfully!": "تم حفظ المسودة بنجاح!",
  "Failed to save draft": "فشل في حفظ المسودة",
  "Branch Trainers": "مدربين الفروع",
  "Please select users to add as trainers": "يرجى تحديد المستخدمين لإضافتهم كمدربين",
  "Add Selected Trainers": "إضافة المستخدمين المحددين",
  "Adding...": "جاري الإضافة...",
  "Trainers added successfully": "تم إضافة المدربين بنجاح",
  "Failed to add trainers": "فشل في إضافة المدربين",
  "Trainer removed successfully": "تم إزالة المدرب بنجاح",
  "Failed to remove trainer": "فشل في إزالة المدرب",
  "Trainers loaded successfully": "تم تحميل المدربين بنجاح",
  "Failed to load trainers": "فشل في تحميل المدربين",
  "Are you sure you want to remove this trainer?": "هل أنت متأكد من رغبتك في إزالة هذا المدرب؟",
  "Trainer": "المدرب",
  "Available Users": "المستخدمين المتاحين",
  "Existing Trainers": "المدربين الموجودين",
  "Search users...": "ابحث في المستخدمين",
  "Trainer ": "اسم المدرب",
  "Search branches": "ابحث في الفروع",
  "Trainer email": "البريد الإلكتروني للمدرب",
  "Trainer phone": "رقم الهاتف للمدرب",
  "Trainer gender": "الجنس للمدرب",
  "Select branches": "اختر الفروع",
  "Load Users": "إرجاع المستخدمين",
  "Are you sure you want to cancel next report": "هل أنت متأكد من رغبتك في إلغاء التقرير التالي؟",
  "Report cancelled successfully": "تم إلغاء التقرير بنجاح",
  "Error cancelling report": "فشل في إلغاء التقرير",
  "CANCELLED": "ملغي",
  "next report to this date is cancled": "التقرير التالي لهذا التاريخ ملغي",
  "Change Manager": "تعديل الخبير",
  "Change Expert": "تعديل",
  "Submit s training": "بيانات ورشة العمل ",
  "S course title": "عنوان الورشة",
  "Enter Title s": "ادخل عنوان الورشة",
  "select image": "اختر صورة",
  "materla upload s": "رفع الملف",
  "s upload image": "رفع الملف",
  "Failed to complete training request": " فشل في إتمام طلب الورشة",
  "Add to kl": "إضافة المواد إلى مكتبة المعرفة",
  "s Expert": "الخبير",
  "image upload evidence": "رفع صورة",
  "Please upload evidence": "يرجى رفع التوثيق",
  "No evidence images added yet. Click Add Evidence to upload images.": "لم يتم إضافة صور التوثيق بعد. انقر على «إضافة التوثيق» لرفع الصور. ",
  "Error in creating training request": "حدث خطأ أثناء إنشاء طلب التدريب",
  "Training request created successfully": "تم إنشاء طلب التدريب بنجاح",
  "Create New Branch": "إنشاء فرع جديد",
  "Add Branch": "إضافة فرع",
  "Select branch": "اختر الفرع",
  "Available": "متاح",
  "Locked": "مقفل",
  "Complete training to rate": "إنهاء التدريب لتقييم",
  "Trainer Rating": "تقييم المدرب",
  "Rate & Review": "تقييم ومراجعة",
  "Title required": "اسم الدورة التدريبية مطلوب",
  "Activity Page 1": "دراسة حالة/ خريطة الذهنية",
  "Activity Page 2": "بطاقات تدريبية",
  "Activity Page 3": "الحوار والمناقشة",
  "Activity Page 4": "دراسة حالة/ خريطة الذهنية ",
  "Answer Box Page": "ورقة عمل ١",
  "Numeric Process Page": "صفحة الخطوات المرقمة والإجابة النموذجية",
  "Services Page": "صفحة التواصل مع الجهات",
  "Authorities Page": "صفحة الوزارات والهيئات",
  "Front Cover Page": "صفحة الغلاف الأول",
  "Indexx": "صفحة الفهرس",
  "Rectangle Diagram Page": "صفحة الخلاصة ١",
  "Circles Page 6": "صفحة الخلاصة ٢",
  "Circle Mind Map Page": "صفحة الخلاصة  ٣",
  "Session Summary Page": "صفحة الخلاصة ٤",
  "Trainer Guidelines Page": "إرشادات المشارك",
  "Participant Guidelines Page": "إرشادات المشارك",
  "Introduction Page": "صفحة المقدمة",
  "Program Guide Page": "صفحة دليل البرنامج",
  "Tools and Materials Page": "صفحة الأدوات والوسائل",
  "Schedule Page (Timeline)": "صفحة الجدول الزمني",
  "Mind Map Page": "صفحة الخريطة الذهنية",
  "First Training Day Page": "صفحة اليوم التدريبي الأول",
  "Select permission": "اختر الصلاحية",
  "Signup": "التسجيل الآمن",
  "Permission details": "تفاصيل الصلاحية",
  "New Request": "طلب جديد",
  "Select the permission you need to request.": "اختر الصلاحية التي ترغب في طلبها",
  "Continue to sign up": "المتابعة إلى التسجيل",
  "Continue to details": "المتابعة إلى التفاصيل",
  "Permission Flow": "سير عمل الصلاحيات",
  "You can now close this page": "يمكنك الآن إغلاق هذه الصفحة.",
  "Go to Home": "الذهاب إلى الصفحة الرئيسية",
  "Your account has been created and permission request has been submitted successfully, you will be contacted soon": "تم إنشاء حسابك وإرسال طلب الصلاحية بنجاح. سيتم التواصل معك قريبًا.",
  "Create request": "إنشاء طلب",
  "Permission": "الصلاحية",
  "Applicant": "مقدم الطلب",
  "Training Day Plan Page": "صفحة خطة اليوم التدريبي",
  "Unit Page": "صفحة الوحدة",
  "Session Page": "صفحة الجلسة",
  "Session Outline Page": "صفحة مخطط الجلسة",
  "Pre-Assessment Page": "التقييم القبلي/ البعدي",
  "Activity Page": "صفحة النشاط",
  "Educational Material Page": "صفحة المادة العلمية",
  "Educational Material Page 1": "صفحة المادة العلمية ١",
  "Educational Material Page 2": "صفحة المادة العلمية ٢",
  "Summary Page": "صفحة الخلاصة",
  "Closing Page": "صفحة الختام",
  "Post-Assessment Page": "صفحة التقويم البعدي",
  "References Page": "صفحة المراجع",
  "Back Cover Page": "صفحة الغلاف الأخير",
  "Intial Pages": "الصفحات الأولى",
  "Page 1": "١",
  "Page 2": "٢",
  "Technical Integration": "الدمج التقني",
  "For querying financial statements": "لاستعلام عن القوائم المالية",
  "Including VAT: SAR 27,606": "شاملاً ضريبة القيمة المضافة: 27,606 ريال سعودي",
  "ONE TIME": "مرة واحدة",
  "Get the Product": "الحصول على المنتج",
  "SERVICE DESCRIPTION": "وصف الخدمة",
  "SERVICE CONDITIONS AND REQUIREMENTS": "الشروط والمتطلبات",
  "TARGET AUDIENCE": "الفئة المستهدفة",
  "OTHER INFORMATION": "معلومات أخرى",
  "Add Service": "إضافة منتج",
  "Add New Service": "إضافة منتج جديدة",
  "Service Name": "اسم منتج",
  "Enter service name": "أدخل اسم منتج",
  "Service Purpose": "هدف المنتج",
  "e.g., For querying financial statements": "مثال: للاستعلام عن القوائم المالية",
  "Service Type": "آلية الدفع",
  "e.g., ONE TIME": "مثال: مرة واحدة",
  "Pricing Information": "معلومات التسعير",
  "Amount": "المبلغ",
  "Currency": "العملة",
  "Price includes VAT": "السعر يشمل ضريبة القيمة المضافة",
  "Service Details": "تفاصيل الخدمة",
  "Service Description": "وصف الخدمة",
  "Enter service description": "أدخل وصف الخدمة",
  "Service Conditions and Requirements": "شروط ومتطلبات الخدمة",
  "Enter service conditions and requirements": "أدخل شروط ومتطلبات الخدمة",
  "Target Audience": "الفئة المستهدفة",
  "Enter target audience": "أدخل الفئة المستهدفة",
  "Other Information": "معلومات أخرى",
  "Enter any other relevant information": "أدخل أي معلومات أخرى ذات صلة",
  "Create New Survey": "إنشاء استبيان جديد",
  "Create New Survey (products services)": "إنشاء نموذج جديد",
  "Add Existing Survey": "إضافة نموذج موجود",
  "Survey Link": "رابط الاستبيان",
  "Enter survey link": "أدخل رابط الاستبيان",
  "Edit Questions": "تعديل الأسئلة",
  "New Survey Details": "تفاصيل الاستبيان الجديد",
  "Select Survey Type": "اختر نوع الاستبيان",
  "Enter Survey Name": "أدخل اسم الاستبيان",
  "Enter Survey Description": "أدخل وصف الاستبيان",
  "Update Service": "تحديث الخدمة",
  "Create Service": "إنشاء الخدمة",
  "Updating...": "جاري التحديث...",
  "Creating...": "جاري الإنشاء...",
  "Service name is required": "اسم الخدمة مطلوب",
  "Amount is required and must be greater than 0": "المبلغ مطلوب ويجب أن يكون أكبر من 0",
  "Service description is required": "وصف الخدمة مطلوب",
  "Service conditions and requirements are required": "شروط ومتطلبات الخدمة مطلوبة",
  "Comment is required": "التعليق مطلوب",
  "Choose File": "اختر ملف",
  "Click to upload file": "انقر لرفع الملف",
  "Open": "فتح",
  "Saving...": "جاري الحفظ...",
  "Accept Order": "قبول الطلب",
  "Reject Order": "رفض الطلب",
  "Submit Order": "إرسال الطلب",
  "Order Summary": "ملخص الطلب",
  "Order ID": "رقم الطلب",
  "Total Amount": "المبلغ الإجمالي",
  "Survey Name": "اسم الاستبيان",
  "Survey Type": "نوع الاستبيان",
  "Questions Answered": "الأسئلة المجاب عليها",
  "View Survey Details": "عرض تفاصيل النموذج",
  "Survey Questions & Answers": "أسئلة وإجابات الاستبيان",
  "Back to Orders": "العودة إلى الطلبات",
  "Product Name": "اسم المنتج",
  "Product Type": "نوع المنتج",
  "Unit Price": "سعر الوحدة",
  "VAT": "ضريبة القيمة المضافة",
  "Add Information": "الإجراء",
  "Information Type": "نوع الإجراء",
  "Attachment": "مرفقات",
  "Enter your comment here...": "أدخل تعليقك هنا...",
  "Complete Service Details": "تفاصيل الخدمة الكاملة",
  "Conditions and Requirements": "الشروط والمتطلبات",
  "Additional Pricing Information": "معلومات التسعير الإضافية",
  "Price for querying a single financial statement is": "سعر الاستعلام عن قائمة مالية واحدة هو",
  "Available Actions": "الإجراءات المتاحة",
  "Edit Service": "تعديل الخدمة",
  "Delete Service": "حذف الخدمة",
  "See More": "عرض المزيد",
  "including VAT": "شامل ضريبة القيمة المضافة",
  "Create New order request": "إرسال طلب",
  "Create New Order": "إرسال طلب جديد",
  "Fill in the details below to create a new order": "املأ التفاصيل أدناه لإرسال طلب",
  "Customer Information": "معلومات ضابط الاتصال للجهة",
  "Customer Name": "الاسم",
  "Enter customer name": "يرجى كتابة اسمك الكامل",
  "Email Address": "عنوان البريد الإلكتروني",
  "Enter email address": "أدخل عنوان البريد الإلكتروني",
  "Enter phone number": "أدخل رقم الهاتف",
  "Enter organization name": "أدخل اسم المنظمة",
  "Service Fees": "رسوم الخدمة",
  "Survey Information": "مرفقات",
  "Please Fill out the survey before placing an order": "يرجى ملء الاستبيان قبل تقديم الطلب",
  "Open Survey": "فتح الاستبيان",
  "Creating Order...": "جاري إرسال طلب...",
  "Create Order": "إرسال طلب",
  "Search by Order ID...": "البحث برقم الطلب...",
  "Search by Customer Email...": "البحث ببريد العميل الإلكتروني...",
  "General Search...": "البحث العام...",
  "Filter by Status": "تصفية حسب الحالة",
  "Total Orders": "إجمالي الطلبات",
  "orders": "طلبات",
  "Refresh": "تحديث",
  "Order Notes": "ملاحظات الطلب",
  "Order History": "تحديثات الطلب",
  "View All History": "عرض كامل التاريخ",
  "more": "المزيد",
  "Update Order Status": "تحديث حالة الطلب",
  "Order": "الطلب",
  "Customer": "العميل",
  "Product": "المنتج",
  "New Status": "الحالة الجديدة",
  "Notes (Optional)": "ملاحظات (اختيارية)",
  "Add any notes about this status change...": "أضف أي ملاحظات حول تغيير الحالة هذا...",
  "Update Status": "تحديث الحالة",
  "Loading order details...": "جاري تحميل تفاصيل الطلب...",
  "Error loading order details": "خطأ في تحميل تفاصيل الطلب",
  "Try again": "حاول مرة أخرى",
  "Product Information": "معلومات المنتج",
  "You do not have permission to delete services.": "ليس لديك صلاحية لحذف الخدمات.",
  "Are you sure you want to delete this service?": "هل أنت متأكد من أنك تريد حذف هذه الخدمة؟",
  "نعم": "نعم",
  "لا": "لا",
  "Failed to delete service": "فشل في حذف الخدمة",
  "Service deleted successfully": "تم حذف الخدمة بنجاح",
  "You do not have permission to update services.": "ليس لديك صلاحية لتحديث الخدمات.",
  "You do not have permission to create services.": "ليس لديك صلاحية لإنشاء الخدمات.",
  "Failed to update service": "فشل في تحديث الخدمة",
  "Service updated successfully": "تم تحديث الخدمة بنجاح",
  "Failed to create service": "فشل في إنشاء الخدمة",
  "Service created successfully": "تم إنشاء الخدمة بنجاح",
  "An error occurred while saving the service": "حدث خطأ أثناء حفظ الخدمة",
  "Order created successfully!": "تم إنشاء نموذج الطلب",
  "Failed to create order. Please try again.": "فشل في إنشاء الطلب. يرجى المحاولة مرة أخرى.",
  "Required Questions": "أسئلة مطلوبة",
  "Please answer all required questions:": "يرجى الإجابة على جميع الأسئلة المطلوبة:",
  "An unexpected error occurred while creating the order.": "حدث خطأ غير متوقع أثناء إنشاء الطلب.",
  "This field is required": "هذا الحقل مطلوب",
  "Value must be at least": "يجب أن تكون القيمة على الأقل",
  "No survey link available.": "لا يوجد رابط استبيان متاح.",
  "Survey created successfully. Survey link added to the service.": "تم إنشاء الاستبيان بنجاح. تم إضافة رابط الاستبيان إلى الخدمة.",
  "Error creating survey. Please try again.": "خطأ في إنشاء الاستبيان. يرجى المحاولة مرة أخرى.",
  "Invalid survey link. Please check and try again.": "رابط استبيان غير صالح. يرجى التحقق والمحاولة مرة أخرى.",
  "Error validating survey link. Please check and try again.": "خطأ في التحقق من صحة رابط الاستبيان. يرجى التحقق والمحاولة مرة أخرى.",
  "Invalid survey link format. Please check and try again.": "تنسيق رابط الاستبيان غير صالح. يرجى التحقق والمحاولة مرة أخرى.",
  "Order Details": "تفاصيل الطلب",
  "Missing required parameters (id)": "معاملات مطلوبة مفقودة (المعرف)",
  "No order found for the specified id": "لم يتم العثور على طلب للمعرف المحدد",
  "No Order Found": "لم يتم العثور على طلب",
  "An error occurred while loading order details": "حدث خطأ أثناء تحميل تفاصيل الطلب",
  "Validation Error": "خطأ في التحقق",
  "Please enter a comment": "يرجى إدخال تعليق",
  "Please upload a file": "يرجى رفع ملف",
  "Failed to add history item": "فشل في إضافة عنصر التاريخ",
  "History item added successfully": "تم إضافة عنصر التاريخ بنجاح",
  "An error occurred while adding history item": "حدث خطأ أثناء إضافة عنصر التاريخ",
  "Failed to update order status": "فشل في تحديث حالة الطلب",
  "Status Updated": "تم تحديث الحالة",
  "successfully, but failed to add history item": "بنجاح، لكن فشل في إضافة عنصر التاريخ",
  "and history item added successfully": "وعنصر التاريخ تم إضافته بنجاح",
  "successfully": "بنجاح",
  "An error occurred while updating order status": "حدث خطأ أثناء تحديث حالة الطلب",
  "Orders": "الطلبات",
  "Failed to load orders": "فشل في تحميل الطلبات",
  "Status Change": "تغيير الحالة",
  "Order status updated successfully": "تم تحديث حالة الطلب بنجاح",
  "Are you sure you want to delete order": "هل أنت متأكد من أنك تريد حذف الطلب",
  "Failed to delete order": "فشل في حذف الطلب",
  "Order deleted successfully": "تم حذف الطلب بنجاح",
  "Created by": "بواسطة",
  "Created at": "تاريخ الإنشاء",
  "Error Loading Order Details": "خطأ في تحميل تفاصيل الطلب",
  "Try Again": "حاول مرة أخرى",
  "Products and Services": "المنتجات",
  "Tutorial Video": "فيديو تعليمي",
  "choose date": "أختر التاريخ",
  "New PopUp Assessment": "تقييم منبثق جديد",
  "this entity has sub divisions": "هذا الكيان يحتوي على أقسام فرعية",
  "You can enter a number (e.g., 1000.00) or text (e.g., 'Not decided yet', 'Price to be determined')": "يمكنك إدخال رقم (مثل 1000.00) أو نص (مثل: لم يتم تحديده بعد، أو سيتم تحديد السعر لاحقاً)",
  "File Uploaded": "تم رفع الملف",
  "File uploaded successfully": "تم رفع الملف بنجاح",
  "Order update and history item added successfully": "تم تحديث الطلب وإضافة عنصر التاريخ بنجاح",
  "UPDATE": "تحديث",
  "Order pending successfully": "تم تعليق الطلب بنجاح",
  "Request Update": "طلب تحديث",
  "Cancel Order": "إلغاء الطلب",
  "Admin Actions": "إجراءات المدير",
  "Order update successfully": "تم تحديث الطلب بنجاح",
  "Order pending and history item added successfully": "تم تعليق الطلب وإضافة عنصر التاريخ بنجاح",
  "Order accepted successfully": "تم قبول الطلب بنجاح",
  "Order rejected and history item added successfully": "تم رفض الطلب وإضافة عنصر التاريخ بنجاح",
  "Order canceled successfully": "تم إلغاء الطلب بنجاح",
  "Search product types...": "البحث عن أنواع المنتجات...",
  "Add Product Type": "إضافة نوع منتج",
  "Letter": "الحرف",
  "Edit Product Type": "تعديل نوع المنتج",
  "Enter product type name": "أدخل اسم نوع المنتج",
  "Enter a single letter (e.g., A, B, C)": "أدخل حرفاً واحداً (مثل: أ، ب، ج)",
  "Enter single letter": "أدخل حرفاً واحداً",
  "Failed to load product types": "فشل تحميل أنواع المنتجات",
  "An error occurred while loading product types": "حدث خطأ أثناء تحميل أنواع المنتجات",
  "Error loading product types:": "خطأ في تحميل أنواع المنتجات:",
  "You do not have permission to update product types": "ليس لديك صلاحية لتحديث أنواع المنتجات",
  "Letter is required": "الحرف مطلوب",
  "Letter must be a single character": "يجب أن يكون الحرف حرفاً واحداً",
  "Failed to update product type": "فشل تحديث نوع المنتج",
  "Product type updated successfully": "تم تحديث نوع المنتج بنجاح",
  "Product type created successfully": "تم إنشاء نوع المنتج بنجاح",
  "Failed to create product type": "فشل إنشاء نوع المنتج",
  "An error occurred while saving the product type": "حدث خطأ أثناء حفظ نوع المنتج",
  "Are you sure you want to delete this product type?": "هل أنت متأكد من حذف نوع المنتج هذا؟",
  "Product type deleted successfully": "تم حذف نوع المنتج بنجاح",
  "An error occurred while deleting the product type": "حدث خطأ أثناء حذف نوع المنتج",
  "Product Types": "أنواع المنتجات",
  "Name is required": "الاسم مطلوب",
  "Failed to delete product type": "فشل حذف نوع المنتج",
  "You do not have permission to delete product types": "ليس لديك صلاحية لحذف أنواع المنتجات",
  "Manage Product Types": "إدارة أنواع المنتجات",
  "Select product type": "اختر نوع المنتج",
  "Loading product types...": "جاري تحميل أنواع المنتجات...",
  "Select Session Type": "اختر نوع الجلسة",
  "Choose the type of session you want to create": "اختر نوع الجلسة التي تريد إنشاءها",
  "Create an in-person session at a physical location": "نظّم جلسة تدريبية في موقع فعلي مع تجربة تعليمية مباشرة",
  "Physical location required": "يتطلب موقعًا فعليًا",
  "Date and time scheduling": "جدولة التاريخ والوقت",
  "Trainer assignment": "إمكانية تعيين مدرب",
  "Create an online video conference session": "إنشاء جلسة أو مؤتمر فيديو عبر الإنترنت بسهولة.",
  "Video conference link": "رابط مباشر لغرفة التدريب الافتراضية",
  "Remote participation": "المشاركة عن بُعد",
  "Real-time interaction": "التفاعل في الوقت الفعلي",
  "Create a video-based session with pre-recorded or live video content": "قدّم تجربة تدريبية مرنة من خلال جلسات تعتمد على الفيديو، سواء مسجّلة مسبقًا أو مباشرة.",
  "Video URL or file upload": "رابط الفيديو أو رفع الملفات",
  "Self-paced learning": "مناسبة للتعلم الذاتي",
  "Preview option available": "خيار المعاينة متاح",
  "Create a certificate for course completion": "إنشاء شهادة لإتمام الدورة",
  "Custom certificate design": "تصميم شهادة مخصص",
  "Digital certificate": "شهادة رقمية",
  "Change Session Type": "تغيير نوع الجلسة",
  "Training Timeline": "الجدول الزمني للتدريب",
  "Timeline View": "عرض الجدول الزمني",
  "Gantt Chart": "مخطط جانت",
  "Bar Chart": "مخطط شريطي",
  "Status Legend": "مفتاح الحالة",
  "Duration (Days)": "المدة (بالأيام)",
  "days": "أيام",
  "No training courses available": "لا توجد دورات تدريبية متاحة",
  "Canceled": "ملغاة",
  "Filter by Date Range": "تصفية حسب النطاق الزمني",
  "Clear Date Filter": "مسح فلتر التاريخ",
  "Info": "معلومات",
  "Chart Information": "معلومات المخطط",
  "Gantt Chart Guide": "دليل مخطط جانت",
  "Gantt Chart Description 1": "يتيح مخطط جانت عرض الجدول الزمني للدورات التدريبية بطريقة منظمة وسهلة المتابعة.",
  "Gantt Chart Description 2": "يمثّل كل شريط دورة تدريبية مع توضيح تاريخ البداية والنهاية.",
  "Gantt Chart Description 3": "تختلف ألوان الشرائط حسب حالة الدورة (قادمة، جارية، مكتملة، أو نقص حضور).",
  "Gantt Chart Description 4": "انقر على أي شريط للانتقال مباشرة إلى صفحة تفاصيل الدورة التدريبية.",
  "Bar Chart Guide": "دليل المخطط الشريطي",
  "Bar Chart Description 1": "يعرض المخطط الشريطي مدة كل دورة تدريبية بالأيام",
  "Bar Chart Description 2": "كل شريط يمثّل دورة تدريبية، وطوله يعكس عدد أيامها.",
  "Bar Chart Description 3": "الألوان المختلفة تشير إلى أنواع متعددة من الدورات. انقر على أي شريط لعرض تفاصيل الدورة بشكل كامل.",
  "Timeline View Guide": "دليل عرض الجدول الزمني",
  "Timeline Description 1": "يعرض قائمة تفصيلية بجميع الدورات التدريبية مرتبة حسب التاريخ",
  "Timeline Description 2": "يمكنك رؤية حالة كل دورة، تواريخها، ونسبة الإتمام",
  "Timeline Description 3": "انقر على أي عنصر في القائمة للانتقال إلى صفحة تفاصيل الدورة التدريبية",
  "Rating Management": "إدارة التقييمات",
  "How to Use Rating": "كيفية استخدام نظام التقييم",
  "Rating Instructions Main Trainer": "كمدرب رئيسي، يمكنك تقييم المستخدمين والمدربين. استخدم علامات التبويب للتبديل بين تقييم المستخدمين وتقييم المدربين.",
  "Rating Instructions Trainer": "بصفتك مدرِّبًا رئيسيًا، يمكنك تقييم كل من المستخدمين والمدربين. استخدم علامات التبويب للتبديل بين تقييمات المستخدمين وتقييمات المدربين.",
  "Rating Instructions User": "كمستخدم، يمكنك تقييم المدربين الذين قاموا بتدريب هذه الدورة.",
  "Rating Instruction 1": "اضغط زر (قيّم) لفتح استبيان التقييم في نافذة جديدة.",
  "Rating Instruction 2": "بعد إكمال التقييم، سيتم عرض التقييم المتوسط تلقائياً",
  "Rating Instruction 3": "يمكنك مراجعة التقييم وتعديله قبل الإرسال النهائي عبر زر (تعديل).",
  "Users Rating": "تقييم المستخدمين",
  "No trainers available": "لا يوجد مدربون متاحون",
  "No users available": "لا يوجد مستخدمون متاحون",
  "No users available for impact measurement": "لا يوجد مستخدمون متاحون لقياس التأثير",
  "Rated": "تم التقييم",
  "Previous": "السابق",
  "How to Use Impact Measurement": "كيفية استخدام ميزة قياس الأثر",
  "Impact Measurement Instructions": "تتيح لك ميزة قياس الأثر جدولة ومتابعة استبيانات التقييم للمستخدمين المسجّلين في هذه الدورة التدريبية.",
  "Impact Instruction 1": "حدِّد تاريخًا ووقتًا لكل مستخدم لإجراء الاستبيان.",
  "Impact Instruction 2": "أضِف رابط Zoom أو أي رابط اجتماع فيديو خاص بالجلسة.",
  "Impact Instruction 3": "اضغط على زر (دعوة) لإرسال الدعوة للمستخدم بعد تعبئة جميع الحقول.",
  "Impact Instruction 4": "بعد إرسال الدعوة، يمكنك تعديل البيانات عبر (إعادة تعيين الجدول) أو (إعادة إجراء الاستبيان)عند الحاجة.",
  "Sending invitation...": "جاري إرسال الدعوة...",
  "My Training Courses (for trainers)": "الدورات التدريبية",
  "My Training Courses": "الدورات التدريبية",
  "View all courses where you are assigned as a trainer": "جميع الدورات التي تم تعيينك فيها كمدرب",
  "No courses found": "لم يتم العثور على دورات",
  "You are not assigned as a trainer to any courses yet": "لم يتم تعيينك كمدرب في أي دورات بعد",
  "Trainer ID not found": "لم يتم العثور على معرف المدرب",
  "Failed to load courses": "فشل تحميل الدورات",
  "An error occurred while loading courses": "حدث خطأ أثناء تحميل الدورات",
  "Untitled Course": "دورة بدون عنوان",
  "Course Dates": "تواريخ الدورة",
  "participants": "مشارك",
  "session(s)": "جلسة",
  "View Course": "عرض الدورة",
  "UPCOMING": "قادمة",
  "ONGOING": "جارية",
  "Join Online Session": "الانضمام إلى الجلسة عبر الإنترنت",
  "more sessions": "جلسات أخرى",
  "View Location": "عرض الموقع",
  "View Location on Map": "عرض الموقع على الخريطة",
  "No online link available": "لا يوجد رابط عبر الإنترنت متاح",
  "No address provided": "لم يتم تقديم عنوان",
  "Attendance saved successfully": "تم حفظ الحضور بنجاح",
  "Sort by": "ترتيب حسب",
  "Created Date (Newest)": "تاريخ الإنشاء (الأحدث)",
  "Created Date (Oldest)": "تاريخ الإنشاء (الأقدم)",
  "Start Date (Newest)": "تاريخ البدء (الأحدث)",
  "Start Date (Oldest)": "تاريخ البدء (الأقدم)",
  "Title (A-Z)": "العنوان (أ-ي)",
  "Title (Z-A)": "العنوان (ي-أ)",
  "Upcoming Sessions Requiring Attendance": "الجلسات القادمة",
  "Today": "اليوم",
  "Tomorrow": "غداً",
  "Online Session Link Available": "رابط الجلسة متاح",
  "This Week": "هذا الأسبوع",
  "This Month": "هذا الشهر",
  "No sessions found for the selected period": "لم يتم العثور على جلسات للفترة المحددة",
  "Session": "جلسة",
  "Training Path Updated": "تم تحديث مسار التدريب",
  "Program created and added to path": "تم إنشاء البرنامج وإضافته إلى المسار",
  "Branch Name": "اسم الفرع",
  "Creating branch...": "جاري إنشاء الفرع...",
  "Enter branch name": "أدخل اسم الفرع",
  "Create Branch": "إنشاء الفرع",
  "Branch name is required": "اسم الفرع مطلوب",
  "Branch created successfully": "تم إنشاء الفرع بنجاح",
  "An error occurred while creating the branch": "حدث خطأ أثناء إنشاء الفرع",
  "Add Optional Trainer": "إضافة مدرب (اختياري)",
  "Add Internal Trainer": "إضافة مدرب داخلي",
  "Add External Trainer": "إضافة مدرب خارجي",
  "Select Trainer Type": "اختر نوع المدرب",
  "Choose the type of trainer you want to add": "اختر نوع المدرب الذي تريد إضافته",
  "Internal Trainer": "مدرب داخلي",
  "External Trainer": "مدرب خارجي",
  "Select from existing internal users": "اختر من المستخدمين الموجودين",
  "Create a new external trainer": "إضافة مدرب جديد",
  "Trainer added successfully!": "تم إضافة المدرب بنجاح",
  "Optional trainer added successfully": "تم إضافة المدرب الاختياري بنجاح",
  "Add in training": "إضافة",
  "Name & Description": "الاسم والوصف",
  "This section is available for trainers only": "هذه الصفحة متاحة للمدربين فقط",
  "Hide Attendance": "إخفاء كشف الحضور",
  "Training Path deleted": "تم حذف مسار التدريب",
  "View/Mark Attendance": "عرض/تسجيل الحضور",
  "Delete Rating Settings": "حذف إعدادات التقييم",
  "Delete Impact Settings": "حذف إعدادات التأثير",
  "Are you sure you want to delete rating settings? This action cannot be undone.": "هل أنت متأكد أنك تريد حذف إعدادات التقييم؟ لا يمكن التراجع عن هذا الإجراء.",
  "Are you sure you want to delete impact settings? This action cannot be undone.": "هل أنت متأكد أنك تريد حذف إعدادات التأثير؟ لا يمكن التراجع عن هذا الإجراء.",
  "Failed to delete rating settings": "فشل حذف إعدادات التقييم",
  "Failed to delete impact settings": "فشل حذف إعدادات التأثير",
  "Rating settings deleted successfully": "تم حذف إعدادات التقييم بنجاح",
  "Impact settings deleted successfully": "تم حذف إعدادات التأثير بنجاح",
  "An error occurred while deleting rating settings": "حدث خطأ أثناء حذف إعدادات التقييم",
  "An error occurred while deleting impact settings": "حدث خطأ أثناء حذف إعدادات التأثير",
  "Training published successfully!": "تم نشر التدريب بنجاح!",
  "Training published successfully": "تم نشر التدريب بنجاح!",
  "invalid Date select in range": "تاريخ غير صالح محدد في النطاق",
  "Title is required": "العنوان مطلوب",
  "Edit Program Details": "تعديل تفاصيل البرنامج",
  "Questions saved successfully": "تم حفظ الأسئلة بنجاح",
  "Courses users updated successfully": "تم تحديث مستخدمي الدورات بنجاح",
  "Failed to add attendees": "فشل في إضافة الحضور",
  "attendees added successfully": "تمت إضافة الحضور بنجاح",
  "Videos of company branch services": "فيديوهات خدمات فروع الشركات",
  "Name copied to clipboard": "تم نسخ الاسم إلى الحافظة",
  "Failed to copy to clipboard": "فشل في نسخ الاسم إلى الحافظة",
  "Loading trainers...": "جاري تحميل المدربين...",
  "The end time cannot be before the start time": "لا يمكن أن يكون وقت الانتهاء قبل وقت البدء",
  "No Employees in this branch": "لايوجد موظفين",
  "No selected attendees": "لم يتم تحديد أي موظفين",
  "Selected Trainer": "المدرب المختار",
  "Material added successfully": "تم إضافة المصادر بنجاح",
  "Select Existing Survey": "حدد استبيان موجود",
  "Loading surveys...": "جاري تحميل الاستبيانات...",
  "Enter amount (e.g., 1000.00) or text (e.g., Not decided yet)": "أدخل المبلغ (مثل: 1000.00) أو نص (مثل: لم يتم تحديده بعد)",
  "Amount is required": "المبلغ مطلوب",
  "Request Survey Update": "طلب تحديث الاستبيان",
  "Survey updated and order status changed to pending": "تم تحديث الاستبيان وتغيير حالة الطلب إلى قيد الانتظار",
  "Save & Update Order": "حفظ وتحديث الطلب",
  "Order update_survey successfully": "تم تحديث الاستبيان وتحديث الطلب بنجاح",
  "Failed to load order details": "فشل في تحميل تفاصيل الطلب",
  "Update Required": "التحديث مطلوب",
  "Comment added successfully": "تم إضافة التعليق بنجاح",
  "Failed to add comment": "فشل في إضافة التعليق",
  "Attachment added successfully": "تم إضافة المرفق بنجاح",
  "Failed to add attachment": "فشل في إضافة المرفق",
  "No email address to copy": "لا يوجد عنوان بريد إلكتروني للنسخ",
  "Email copied to clipboard": "تم نسخ البريد الإلكتروني إلى الحافظة",
  "Failed to copy email to clipboard": "فشل في نسخ البريد الإلكتروني إلى الحافظة",
  "Warning": "تحذير",
  "Anonymous survey PDF export is disabled": "تصدير PDF غير متاح للاستبيانات المجهولة لأنه يعرض بيانات المشاركين",
  "All Orders": "جميع الطلبات",
  "UPDATE_SURVEY": "تحديث الاستبيان",
  "No manager exists for this OU": "لا يوجد خبير لهذه الجهة",
  "No assessments found matching your search": "لا توجد اختبارات مطابقة للبحث",
  "Search assessments...": "ابحث في الاختبارات...",
  "Search survey...": "ابحث في الاستبيانات...",
  "Enter survey link or select from above": "أدخل رابط الاستبيان أو اختر من الأعلى",
  "View Full History": "عرض السجل الكامل",
  "External trainer added successfully": "تمت إضافة المدرب الخارجي بنجاح",
  "Training program updated": "تم تحديث البرنامج التدريبي",
  "Edit Path Details": "تعديل تفاصيل المسار",
  "End time cannot be earlier than or equal to start time": "لا يمكن أن يكون وقت الانتهاء قبل أو يساوي وقت البدء",
  "View Training": "عرض التدريب",
  "Gender is required": "الجنس مطلوب",
  "No training requests found": "لم يتم العثور على طلبات تدريب",
  "Try adjusting your filters or create a new training request.": "حاول تعديل عوامل التصفية أو إنشاء طلب تدريب جديد.",
  "Path updated successfully": "تم تحديث المسار بنجاح",
  "Set Reminder": "تعيين تذكير",
  "Previous Year": "السنة السابقة",
  "Next Year": "السنة القادمة",
  "Loading calendar data...": "جارٍ تحميل بيانات التقويم...",
  "Request permission": "طلب الصلاحيات",
  "User and permission request created successfully": "تم إنشاء المستخدم وطلب الصلاحيات بنجاح",
  "Your account has been created and permission request has been submitted successfully, you will be contacted soon.": "تم إنشاء حسابك وتقديم طلب الصلاحيات بنجاح، سيتم التواصل معك قريبًا.",
  "You can now close this page.": "يمكنك الآن إغلاق هذه الصفحة.",
  "Worst Performing Question Percentage": "الأسئلة التي حصلت على أعلى نسبة من الأخطاء",
  "attempts": "محاولات",
  "Program updated successfully": "تم تحديث البرنامج بنجاح",
  "Please enter permission name": "يرجى إدخال اسم الصلاحية",
  "Permission created successfully": "تم إنشاء الصلاحية بنجاح",
  "Appreciation": "التقدير",
  "Download Excel (PDF Format)": "تحميل إكسل (صيغة PDF)",
  "Download PDF with Data": "تنزيل ملف PDF مع البيانات",
  "Download Cache Attempts": "تنزيل محاولات التخزين المؤقت ",
  "Correct and Incorrect Answers Statistics": "إحصائيات الإجابات الصحيحة والإجابات الخاطئة",
  "Percentage of participants by grade": "نسبة المشاركين حسب التقدير",
  "Total correct answers": "إجمالي الإجابات الصحيحة",
  "General information": "معلومات عامة",
  "Overall average": "المعدل العام",
  "Worst Performing Questions": "أسوأ الأسئلة أداءً",
  "Selection counts": "عدد المختبرين",
  "Total number of survey types": "إجمالي أنواع الاستبيانات",
  "Total number of surveys": "إجمالي عدد الاستبيانات",
  "Total number of questions": "إجمالي عدد الأسئلة",
  "Minimum questions per survey": "الحد الأدنى للأسئلة في الاستبيان",
  "Total internal participants": "إجمالي المشاركين الداخليين",
  "Internal respondents": "المستجيبون الداخليون",
  "Total external participants": "إجمالي المشاركين الخارجيين",
  "External respondents": "المستجيبون الخارجيون",
  "Total number of survey participants": "إجمالي عدد المشاركين في الاستبيان",
  "Total number of respondents": "إجمالي عدد المستجيبين",
  "Total number of missing respondents": "عدد المستجيبين المتغيبين",
  "Items ranked by priority (Top to Bottom):": "الأصناف مرتبة حسب الأولوية (من الأعلى إلى الأسفل):",
  "Rank": "الترتيب",
  "Item": "العنصر",
  "Top Answer": "الإجابة الأعلى",
  "Courses": "الدورات",
  "Distribution over ranks": "توزيع الرتب",
  "Participants": "مشاركون",
  "Number of Participants": "عدد المشاركين",
  "Results Analysis By Question": "تحليل النتائج على مستوى الأسئلة",
  "No Preview": "إخفاء المعاينة",
  "The Form": "النموذج",
  "Workflow": "سير العمل",
  "Timeline": "الجدول الزمني",
  "Lock Timeline Editing": "قفل تعديل الجدول الزمني",
  "Unlock Timeline Editing": "إلغاء قفل تعديل الجدول الزمني",
  "Timeline Editing Locked": "تعديل الجدول الزمني مقفل",
  "Page Content": "محتوى الصفحة",
  "No schema defined for this template type": "لا يوجد نموذج محدد لهذا النوع من القوالب",
  "Schedule table edits in Timeline tab": "انقر على تبويب (الجدول الزمني) لإضافة معلومات الجدول الزمني. للانتقال إلى الخطوة التالية، يجب العودة إلى تبويب (النموذج) ثم الضغط على زر (التالي).",
  "Current Status": "الحالة الحالية",
  "Page Number": "رقم الصفحة",
  "Send for Review": "إرسال للمراجعة",
  "Request Changes": "طلب تعديلات",
  "This page has been approved": "تم اعتماد هذه الصفحة",
  "This page has been rejected": "تم رفض هذه الصفحة",
  "Resend for Review": "إعادة الإرسال للمراجعة",
  "Add a comment (optional)": "أضف تعليق (اختياري)",
  "Page Management": "إدارة الصفحات",
  "Graphics": "قوالب جاهزة",
  "Add Above": "إضافة صفحة أعلى الصفحة الحالية",
  "Add Below": "إضافة صفحة أسفل الصفحة الحالية",
  "Delete Page": "حذف الصفحة",
  "Custom BG": "خلفية مخصصة",
  "Graphic BG V5": "عناصر رسومية (1)",
  "Graphic BG V6": "عناصر رسومية (2)",
  "Trainer Instructions": "إرشادات المدرب",
  "Are you sure you want to delete this page?": "هل أنت متأكد من حذف هذه الصفحة؟",
  "Instructor Guidelines": "إرشادات المدرب",
  "Guidelines": "الإرشادات",
  "Edit Table": "تعديل الجدول",
  "Add new item": "أضف عنصر جديد",
  "Enter text here": "اكتب النص هنا",
  "No items found": "لا توجد عناصر",
  "instructor-guidelines-bg": "إرشادات المدرب",
  "v4-custom-background-bg": "خلفية مخصصة",
  "v5-graphic-background-bg": "عناصر رسومية (1)",
  "v6-graphic-background-bg": "عناصر رسومية (2)",
  "mind-map": "الخريطة الذهنية",
  "investment-services": "خدمات الاستثمار",
  "investment-service": "خدمة الاستثمار",
  "Select Layer to Edit": "اختر الطبقة للتعديل",
  "Main Page": "الصفحة الرئيسية",
  "Graphic Background Boxes": "محتوى العناصر الرسومية",
  "Graphic Background V6 Boxes": "محتوى العناصر الرسومية",
  "Boxes Content": "مربع النص",
  "Box Text": "النص",
  "Select Icon": "اختر أيقونة",
  "Add days to start creating the timeline": "أضف أياماً للبدء في إنشاء الجدول الزمني",
  "element": "عنصر",
  "Add Unit": "إضافة وحدة",
  "Session presentations": "عروض الجلسة",
  "Show Sessions": "عرض الجلسات",
  "No items found for this day. Click on \"Add Unit\" or \"Add Break\" to start.": "لم يتم العثور على عناصر لهذا اليوم. انقر فوق \"إضافة وحدة\" أو \"إضافة استراحة\" للبدء.",
  "procedure": "الإجراء",
  "Time in minutes": "الوقت بالدقائق",
  "the topic": "الموضوع",
  "Details": "التفاصيل",
  "The session number": "رقم الجلسة",
  "Time": "الوقت",
  "Remove Topic": "حذف الموضوع",
  "Total time for session topics in the unit:": "إجمالي وقت مواضيع الجلسة في الوحدة:",
  "minutes": "دقيقة",
  "Select number of Activity Pages": "اختر عدد صفحات الأنشطة",
  "Confirm Deletion": "تأكيد الحذف",
  "Yes, Delete": "نعم، احذف",
  "Are you sure you want to delete the entire Mind Map from this page?": "هل أنت متأكد من حذف الخريطة الذهنية بالكامل من هذه الصفحة؟",
  "Page Created": "تم إنشاء الصفحة",
  "Content moved to new page": "تم نقل المحتوى إلى صفحة جديدة",
  "PDF History": "سجل ملفات الحقيبة التدريبية",
  "Current PDF": "ملف الحقيبة التدريبية الحالي",
  "Duplication History": "سجل التكرار",
  "Duplicated on": "تم تكراره في",
  "Duplicated by": "تم تكراره بواسطة",
  "PDF duplicated as draft": "تم نسخ ملف الحقيبة التدريبية كمسودة بنجاح",
  "Duplicate and Rename PDF": "نسخ وإعادة تسمية ملف الحقيبة التدريبية",
  "New Title": "العنوان الجديد",
  "The new PDF will be created as a Draft.": "سيتم إنشاء ملف الحقيبة التدريبية الجديد كمسودة.",
  "Duplicate without Renaming": "نسخ بدون إعادة تسمية",
  "Duplicate & Rename": "نسخ وإعادة تسمية",
  "Duplicating...": "جاري النسخ...",
  "Enter new title...": "أدخل عنوانًا جديدًا...",
  "PDF deleted successfully": "تم حذف ملف الحقيبة التدريبية بنجاح",
  "Circles BG": "إضافة مخطط دائري",
  "Table-BG":"إضافة جدول",
  "Confirm Duplicate": "تأكيد التكرار",
  "Preparing document for printing...": "جاري تحضير المستند للطباعة...",
  "pages": "صفحات",
  "You do not have permission to view this PDF": "ليس لديك صلاحية لعرض هذا الملف",
  "My Templates": "قوالبي",
  "Switch to Free Mode": "التبديل إلى الوضع الحر",
  "Switch to Guided Mode": "التبديل إلى الوضع الموجه",
  "Request Training Program": "طلب برنامج تدريبي",
  "Submit a request for a new training program or workshop": "تقديم طلب لبرنامج تدريبي جديد أو ورشة عمل",
  "Total Responses": "إجمالي الاستجابات",
  "Option": "الخيار",
  "Count": "العدد",
  "Box Main": "المربع الرئيسي",
  "Box Left": "إضافة مربع يسارًا",
  "Box Right": "إضافة مربع يمينًا ",
  "On Left": "إضافة فرع إلى اليسار",
  "On Right": "إضافة فرع إلى اليمين",
  "Hide Mind Map": "إخفاء الخريطة الذهنية ",
  "Show Mind Map": "إظهار الخريطة الذهنية",
  "Initial Save Required": "الحفظ الأولي مطلوب",
  "Please save your PDF to continue.": "يرجى حفظ الحقيبة التدريبية للمتابعة.",
  "This folder contains connected versions and copies.": "يحتوي هذا المجلد على إصدارات ونسخ متصلة.",
  "New comments available": "توجد تعليقات جديدة",
  "Clear all notifications":"حذف جميع الإشعارات",
  "Back to Year View": "العودة إلى عرض السنة",
  "Uploaded Images": "الصور المرفوعة",
  "Loading organization data...": "جاري تحميل بيانات المنظمة...",
  "Search": "بحث",
  "Checked users will receive the training. Use the header checkbox to select or deselect all.": "سيستلم المستخدمون المحددون التدريب. استخدم مربع الاختيار في رأس الجدول لتحديد الكل أو إلغاء تحديد الكل.",
  "OU attendee limit reached": "وصلت هذه الجهة إلى الحد الأقصى المسموح وهو {n} متدربين. يرجى إزالة أحد المستخدمين قبل إضافة آخر.",
  "Select organisational unit":"اختر جهة",
  "No comments yet.": "لا توجد تعليقات بعد.",
  "Load More": "تحميل المزيد",
  "Save Current Page":"حفظ الصفحة الحالية",
  "You do not have permission to create training for any OU": "ليس لديك صلاحية لإنشاء تدريب لأي جهة",
  "Unsaved Changes": "تغييرات غير محفوظة",
  "You have unsaved changes. Save before leaving?": "لديك تغييرات غير محفوظة. هل تريد الحفظ قبل المغادرة؟",
  "Pending changes": "التغييرات المعلقة",
  "Leave Without Saving": "المغادرة بدون حفظ",
  "Edited page {page} content (not saved)": "تم تعديل محتوى الصفحة {page} (غير محفوظ)",
  "Added page {page} (not saved)": "تمت إضافة الصفحة {page} (غير محفوظ)",
  "Deleted page {page} (not saved)": "تم حذف الصفحة {page} (غير محفوظ)",
  "Duplicated page {from} to page {to} (not saved)": "تم تكرار الصفحة {from} إلى الصفحة {to} (غير محفوظ)",
  "Advanced guided step {step} (not saved)": "خطوة إرشاد متقدمة {step} (غير محفوظ)",
  "Added {count} guided step (not saved)": "تمت إضافة {count} خطوة إرشاد (غير محفوظ)",
  "Added {count} guided steps (not saved)": "تمت إضافة {count} خطوات إرشاد (غير محفوظ)",
  "Added {count} guided page at step {step} (not saved)": "تمت إضافة {count} صفحة إرشاد في الخطوة {step} (غير محفوظ)",
  "Added {count} guided pages at step {step} (not saved)": "تمت إضافة {count} صفحات إرشاد في الخطوة {step} (غير محفوظ)",
  "Send Email":"إرسال بريد إلكتروني",
  "Training path published successfully":"تم نشر المسار التدريبي بنجاح",
  "Attendees List":"قائمة الحضور",
  "Add to Course": "أضف إلى الدورة",
  "Register for Training": "سجل في التدريب",
  "File Upload Successfully": "تم رفع الملف بنجاح",
  "Knowledge library created successfully": "تم اضافة الملف بنجاح",
  "Knowledge library updated successfully": "تم تحديث مكتبة المعرفة بنجاح",
  "Knowledge library deleted successfully": "تم حذف مكتبة المعرفة بنجاح",
  "Failed to update Knowledge library": "فشل تحديث مكتبة المعرفة",
  "Failed to delete Knowledge library": "فشل حذف مكتبة المعرفة",
  "Knowledge library category created successfully": "تم إنشاء تصنيف مكتبة المعرفة بنجاح",
  "Knowledge library category updated successfully": "تم تحديث تصنيف مكتبة المعرفة بنجاح",
  "Failed to update Knowledge library category": "فشل تحديث تصنيف مكتبة المعرفة",
  "select":"اختر",
  "Images":"صورة",
  "Show Thumbnails": "عرض الصور المصغرة",
  "Hide Thumbnails": "إخفاء الصور المصغرة",
  "Timeline Page":"الخطة الزمنية",
  "Move to Index Page":"انتقل إلى صفحة الفهرس",
  "No images found":"لا توجد صور",
  "Timeline updated successfully":"تم تحديث الخطة الزمنية بنجاح",
  "User removed successfully":"تمت إزالة المستخدم بنجاح",
  "Failed to fetch training requests":"فشل استرجاع طلبات التدريب",
  "No training items found":"لا توجد عناصر تدريب",
  "Try adjusting your filters or search criteria":"حاول تعديل الفلاتر أو معايير البحث",
  "Add to KL":"أضف لمكتبة المعرفة",
  "Add Training to Knowledge Library":"إضافة التدريب إلى مكتبة المعرفة",
  "Data signed successfully.....":"تم توقيع البيانات بنجاح.....",
  "Clone":"نسخ",
  "Cloning...":"جارٍ النسخ...",
  "Clone Training Bag": "نسخ الحقيبة التدريبية",
  "Bags":"حقائب",
  "Training Calendar":"التقويم التدريبي"
}